<template>
    <div class="historial">
        <v-container class="my-5">
            <!--    Diálogo Persistente para mostrar Mensaje   -->
            <v-dialog v-model="bandConfirm"
                      persistent
                      width="400"
            >
                <v-card class="justify-center">
                    <v-card-title class="warning display-1 text--primary justify-center"
                          primary-title>
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text>
                        <div class="text-xs-center">
                          {{$t('at_least_one_data')}}
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                @click="bandConfirm = false"
                        >
                            {{$t('aceptar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogTransport" persistent max-width="400px">
                  <v-card class="justify-center">
                      <v-toolbar dark color="primary">
                          <v-toolbar-title>
                              {{$t('carrier_data')}}
                          </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text class="text-xs-center">
                          <v-radio-group
                              row
                              v-model="typeService"
                              prepend-icon="trolley"
                              name="typeService"
                              :mandatory="false"
                              :error-messages="errores.typeService"
                          >
                            <v-radio :label="$t('load')" :value="true"></v-radio>
                            <v-radio :label="$t('download')" :value="false"></v-radio>
                          </v-radio-group>
                          <v-text-field
                              v-model="case_plates"
                              prepend-icon="inventory"
                              name="case_plates"
                              :label="$t('case_plates')"
                              :error-messages="errores.case_plates"
                          >
                          </v-text-field>
                          <v-text-field
                              v-model="container_platform_plates"
                              prepend-icon="local_shipping"
                              name="container_platform_plates"
                              :label="$t('container_platform_plates')"
                              :error-messages="errores.container_platform_plates"
                          >
                          </v-text-field>
                          <v-text-field
                              v-model="transport_line"
                              prepend-icon="rv_hookup"
                              name="transport_line"
                              :label="$t('transport_line')"
                              :error-messages="errores.transport_line"
                          >
                          </v-text-field>
                          <v-text-field
                              v-model="supplier_customer_name"
                              prepend-icon="business"
                              name="supplier_customer_name"
                              :label="$t('supplier_customer_name')"
                              :error-messages="errores.supplier_customer_name"
                          >
                          </v-text-field>
                      </v-card-text>
                      <v-card-actions class="justify-center">
                          <v-btn
                                  color="primary"
                                  @click="dialogTransport = false"
                          >{{ $t('cancelar') }}
                          </v-btn>
                        <v-spacer/>
                        <v-btn
                            v-if="getProfile.roll === 5"
                            color="primary"
                            @click="addAccessCarrierData"
                            :loading="loading"
                        >{{$t('guardar')}}
                        </v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            @click="dialogTransport = false"
                        >{{$t('aceptar')}}
                        </v-btn>
                      </v-card-actions>
                  </v-card>
            </v-dialog>
            <v-dialog v-model="dialogShowPlacas" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{$t('placas')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                    <v-img
                        :src="imagenPlacas"
                        position="center center"
                        class="grey lighten-2"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogShowPlacas = false, imagenPlacas = ''"
                      >{{ $t('cerrar') }}
                      </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
            <!--    Diálogo para Cambiar Invitado de la Invitacion empresarial Recurrente        -->
            <v-dialog v-model="dialogChangeGuest" max-width="500">
                <v-form>
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('cambiar_empleado_asignado')}}
                            </v-toolbar-title>
                            <v-spacer/>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialogChangeGuest = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div>
                                <div>
                                    {{$t('msg_current_employee')}}<br>

                                <li>{{dataQR.guest}}</li>
                                <li>{{dataQR.guest_mail}}</li><br>
                                {{$t('msg_current_employee2')}}<br>
                                </div>
                            </div>
                            <v-layout row wrap>
                                <v-autocomplete
                                        return-object
                                        v-model="email"
                                        :items="items"
                                        prepend-icon="email"
                                        :loading="isLoading"
                                        :search-input.sync="search"
                                        item-text="email"
                                        item-value="celular"
                                        :placeholder="$t('placeholder_invitados')"
                                        :label="$t('Empleados')"
                                        :error-messages="errores.guest"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                >
                                    <v-flex>
                                        <template v-slot:selection="data">
                                            <v-chip
                                                    :selected="data.selected"
                                                    class="chip--select-multi"
                                            >
                                                {{ data.item.email }}
                                            </v-chip>
                                        </template>
                                    </v-flex>
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{data.item.first_name}} {{data.item.last_name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ data.item.email }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>
                                </v-autocomplete>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    outlined
                                    color="primary"
                                    @click="dialogChangeGuest = false"
                            >
                                {{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    outlined
                                    color="primary"
                                    :loading="loadingChangeGuest"
                                    @click="changeGuest()"
                                    :disabled="email === undefined || email === ''"
                            >
                                {{$t('modificar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!--    Diálogo Modal para Cambiar la Hora de la Invitación Emitida       -->
            <v-dialog v-model="dialog_changeHour" max-width="500">
                <v-layout align-center justify-center fill-height>
                    <v-card>
                        <v-card-title class="headline">
                            Cambiar Hora de la Invitación
                        </v-card-title>

                        <v-card-text>
                            Esta funcionalidad está hecha con la finalidad de que el Vigilante de la Empresa pueda darle acceso a su invitado.<br><br>
                            <strong>Nota</strong>: El sistema tiene un rango de toleracia de 5 minutos para dar accesos. <br><br>
                            <v-flex xs12 sm6>
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="hora"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                v-model="hora"
                                                :label="$t('hora_inv')"
                                                prepend-icon="access_time"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="menu"
                                            v-model="hora"
                                            format="24hr"
                                            full-width
                                            @click:minute="$refs.menu.save(hora)"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                    color="primary"
                                    @click="dialog_changeHour = false"
                            >
                                {{$t('cerrar')}}
                            </v-btn>

                            <v-btn
                                    color="primary"
                                    @click="changeHourInvitation()"
                            >
                                {{$t('modificar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-dialog>
            <!--    Diálogo Modal para Confirmación Eliminar Invitación        -->
            <v-dialog v-model="dialog_elimnar" max-width="290">
                <v-card>
                    <v-card-title class="headline">
                        {{$t('msg_cancelar_invitacion')}}
                    </v-card-title>

                    <v-card-text>
                        {{$t('msg_eliminar_invitacion_2')}}
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialog_elimnar = false"
                        >
                            No
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                @click="cancelar_invitacion()"
                        >
                            {{$t('Si')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--    Diálogo Modal para agregar comentarios        -->
            <v-dialog v-model="dialogComments" max-width="500">
                <v-card>
                    <v-card-title class="headline">
                        {{$t('comments')}}
                    </v-card-title>

                    <v-card-text>
                        <v-flex xs12>
                            {{$t('add_comments')}}<br>
                            {{bandAddComments === false ? $t('msg_only_edit_comments') : ''}}
                            <v-textarea
                                    class="pt-3 pb-3"
                                    v-model="comments"
                                    prepend-icon="insert_comment"
                                    name="comments"
                                    :counter="300"
                                    :maxlength="300"
                                    :label="$t('comments')"
                            >
                            </v-textarea>
                        </v-flex>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogComments = false"
                        >
                            {{$t('cancelar')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                v-show="bandVeto === false"
                                color="error"
                                @click="tipo = null, motivo = '', errores = [], dialogVeto = true"
                        >
                            <v-icon>
                              no_accounts
                            </v-icon>
                            <v-spacer/>
                            {{ $t('ban_user') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                :disabled="bandAddComments === false && getProfile.roll === 1"
                                color="primary"
                                :loading="loadingNotifyAccess"
                                @click="add_comments()"
                        >
                            {{ bandAddComments ? $t('agregar') : $t('modificar')  }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--    Diálogo Modal para Vetar a Usuarios        -->
            <v-dialog v-model="dialogVeto" max-width="500">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('ban_user')}}
                        </v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogVeto = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-label>{{ $t('select_type_ban') }}</v-label>
                      <v-radio-group
                          row
                          v-model="tipo"
                          name="tipo"
                          :mandatory="false"
                          :error-messages="errores.tipo"
                      >
                        <v-icon>event_note</v-icon><v-radio :label="$t('period2')" :value=1></v-radio>
                        <v-icon>all_inclusive</v-icon><v-spacer/><v-radio :label="$t('undefined')" :value=2></v-radio>
                      </v-radio-group>
                      <v-layout row wrap v-show="tipo === 1">
                        <v-flex xs12 sm6>
                          <v-menu
                              v-model="modalFechaInicial"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="fecha_inicial"
                                  :label="$t('Fecha_ini')"
                                  prepend-icon="event"
                                  :error-messages="errores.fecha_inicial"
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fecha_inicial"
                                :min="get_current_date2()"
                                :locale="$t('region')"
                                @input="modalFechaInicial = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-menu
                                v-model="modalFechaFinal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="fecha_final"
                                    :label="$t('Fecha_fin')"
                                    prepend-icon="event"
                                    :error-messages="errores.fecha_final"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="fecha_final"
                                  :min="get_current_date2()"
                                  :locale="$t('region')"
                                  @input="modalFechaFinal = false"
                              ></v-date-picker>
                            </v-menu>
                        </v-flex>
                      </v-layout>
                      <v-textarea
                          class="pt-3 pb-3"
                          v-model="motivo"
                          prepend-icon="insert_comment"
                          name="motivo"
                          :error-messages="errores.motivo"
                          :counter="256"
                          :maxlength="256"
                          :label="$t('reason')"
                      >
                      </v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogVeto = false"
                        >
                            {{$t('cancelar')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                :disabled="bandAddComments === false && getProfile.roll === 1"
                                color="primary"
                                :loading="loadingNotifyAccess"
                                @click="add_veto()"
                        >
                            {{ bandAddComments ? $t('agregar') : $t('modificar')  }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Diálogo de visualización -->
            <v-dialog v-model="dialogShowDocument" max-width="900px">
                <v-card>
                    <v-toolbar flat color="primary" dark>
                    <v-toolbar-title>Visualizador de Archivo</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <!-- Botón Descargar -->
                    <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                        <v-icon>cloud_download</v-icon>
                    </v-btn>

                    <!-- Botón Cerrar -->
                    <v-btn icon @click="dialogShowDocument = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    </v-toolbar>

                    <v-card-text>
                    <!-- PDF -->
                    <div v-if="isPdf" style="height: 80vh;">
                        <iframe
                        :src="fileUrl"
                        width="100%"
                        height="100%"
                        frameborder="0"
                        ></iframe>
                    </div>

                    <!-- Imagen -->
                    <div v-else style="text-align: center;">
                        <img
                        :src="fileUrl"
                        alt="Imagen"
                        style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                        />
                    </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDocumentationCorrection" scrollable max-width="500px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Solicitar corrección de documentos
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogDocumentationCorrection = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="missingDocumentations.length > 0">
                        <p>
                            Seleccione los documentos que desee solicitar que se revisen o corrijan
                        </p>
                        <v-layout wrap class="text-xs-center">
                            <template v-for="doc in missingDocumentations">
                                <v-checkbox
                                    v-if="doc.documentationId !== null && !doc.name.includes('INE')"
                                    :key="doc.documentationId"
                                    v-model="selectedDocument"
                                    :value="doc.documentationId"
                                    :label="doc.name"
                                    >
                                </v-checkbox>
                            </template>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn 
                            color="primary"
                            @click="mandarCorrecionDocumentos()"
                            :loading="loadingDocumentsCorrection"
                        >
                            Solicitar correccion
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDocumentos" scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Documentos Adjuntos
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogDocumentos = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout wrap class="text-xs-center">
                            <template v-for="(doc, key) in missingDocumentations">
                            <v-flex v-if="doc.documentationId !== null" xs12 sm6 :key="`preview-${key}`" class="mb-5 px-2">
                                <v-card outlined class="pa-4">
                                <div class="font-weight-bold">{{ doc.name }}</div>
                                <div class="text-xs-center my-3">
                                    <v-chip
                                        v-if="doc.file"
                                        color="green"
                                        text-color="white"
                                        small
                                    >
                                        <v-icon left small>check_circle</v-icon>
                                        Archivo adjunto
                                    </v-chip>
                                    <v-chip
                                        v-else
                                        color="orange"
                                        text-color="white"
                                        small
                                    >
                                        <v-icon left small>warning</v-icon>
                                        Falta documento
                                    </v-chip>
                                </div>
                                <div v-if="doc.file" class="grey--text text--darken-1 text-truncate mb-3" style="max-width: 100%; font-size: 0.85rem;">
                                    {{ doc.is_valid ? '✓ Validado' : '⚠ Pendiente validación' }}
                                </div>
                                <v-btn
                                    small
                                    color="primary"
                                    class="mt-3"
                                    @click="openDialog(doc.file)"
                                    :disabled="!doc.file"
                                >
                                    <v-icon small left>visibility</v-icon>
                                    Visualizar
                                </v-btn>
                                </v-card>
                            </v-flex>
                            </template>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions class="justify-center" v-if="info_invitation.length > 0">
                        <v-btn
                            v-if="info_invitation[0].documentationByInvitation && info_invitation[0].documentationByInvitation.length > 0"
                            color="primary"
                            :disabled="info_invitation[0].documentationCorrection || hasMissingDocuments"
                            @click="selectedDocument = []; dialogDocumentationCorrection = true"
                        >
                            <v-icon left>edit</v-icon>
                            Solicitar corrección de documentos
                        </v-btn>
                        <v-chip
                            v-else-if="hasMissingDocuments"
                            color="orange"
                            text-color="white"
                        >
                            <v-icon left>warning</v-icon>
                            Faltan documentos por cargar
                        </v-chip>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_detail_invit_recibidas" scrollable width="700">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit_recibidas')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit_recibidas = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="info_invitation_recibida.length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].dateInv}}  {{ info_invitation_recibida[0].timeInv}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].hostFirstName}}
                                                            {{ info_invitation_recibida[0].hostLastName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Area')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].areaName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].asunto}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Notas')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].notas}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('mensaje_vehiculo')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].automovil ? $t('Si') : "No" }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('equipo_seguridad')}}
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h3>
                                                            <div v-if="info_invitation_recibida[0] && info_invitation_recibida[0].secEqu" v-for="(equipo, index) in info_invitation_recibida[0].secEqu" v-bind:key="equipo.index">
                                                                <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                            </div>
                                                        </h3>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].diary && info_invitation_recibida[0].diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida[0].expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].confirmed === false && !info_invitation_recibida[0].declined">
                                                    <td colspan="2">
                                                        <h2>
                                                            {{$t('asistira')}}:
                                                        </h2>
                                                        <v-btn
                                                                color="primary"
                                                                :loading="loading_si"
                                                                @click="confirmar_invitacion(info_invitation_recibida[0].qr_code, 'True')"
                                                                dark>{{$t('Si')}}
                                                            <v-icon dark right>check_circle</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                                color="red"
                                                                :loading="loading_no"
                                                                @click="rechazar_invitacion(info_invitation_recibida[0].qr_code)"
                                                                dark>{{$t('No')}}
                                                            <v-icon dark right>block</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].confirmed === true">
                                                    <td colspan="2">
                                                        <v-chip color="green" text-color="white">
                                                            <v-icon left>check_circle</v-icon>
                                                            {{$t('Aceptada')}}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="info_invitation_recibida.length > 0 && info_invitation_recibida[0].declined === true">
                                                    <td colspan="2">
                                                        <v-chip color="red" text-color="white">
                                                            <v-icon left>block</v-icon>
                                                            {{$t('Rechazada')}}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_detail_invit_recibidas_park" scrollable width="700">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit_recibidas')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit_recibidas_park = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="Object.keys(info_invitation_recibida_park).length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.dateInv}}  {{ info_invitation_recibida_park.invitation.timeInv}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.host.first_name}}
                                                            {{ info_invitation_recibida_park.host.last_name}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Parque')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.park_name}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.subject}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Notas')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.notes}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('mensaje_vehiculo')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.vehicle ? $t('Si') : "No" }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_park.invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation_recibida_park.invitation.diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_park.invitation.typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation_recibida_park.invitation.expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation_recibida_park.confirmed === false && !info_invitation_recibida_park.declined">
                                                    <td colspan="2">
                                                        <h2>
                                                            {{$t('asistira')}}:
                                                        </h2>
                                                        <v-btn
                                                                color="primary"
                                                                :loading="loading_si"
                                                                @click="confirmar_invitacion_park(info_invitation_recibida_park.invitation.id, 'True')"
                                                                dark>{{$t('Si')}}
                                                            <v-icon dark right>check_circle</v-icon>
                                                        </v-btn>
                                                        <v-btn
                                                                color="red"
                                                                :loading="loading_no"
                                                                @click="rechazar_invitacion_park(info_invitation_recibida_park.invitation.id)"
                                                                dark>{{$t('No')}}
                                                            <v-icon dark right>block</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="info_invitation_recibida_park.confirmed === true">
                                                    <td colspan="2">
                                                        <v-chip color="green" text-color="white">
                                                            <v-icon left>check_circle</v-icon>
                                                            {{$t('Aceptada')}}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="info_invitation_recibida_park.declined === true">
                                                    <td colspan="2">
                                                        <v-chip color="red" text-color="white">
                                                            <v-icon left>block</v-icon>
                                                            {{$t('Rechazada')}}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_detail_invit" scrollable width="1000">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_invit')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_invit = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="info_invitation.length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <h2>{{$t('info_invitado')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex v-if="info_invitation.length > 0 && info_invitation[0].guest_ine_frente !== null" class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="info_invitation[0].guest_ine_frente"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                            <v-btn
                                                color="primary"
                                                class="mt-2"
                                                v-if="info_invitation.length > 0 && info_invitation[0].documentationByInvitation && info_invitation[0].documentationByInvitation.length > 0"
                                                :loading="loadingDocumentation"
                                                @click="showDocumentation()"
                                            >
                                                Ver Documentos Adjuntos
                                            </v-btn>
                                            <v-btn
                                                v-if="typeof info_invitation[0].ine_update_pending === 'boolean' && getProfile.id_company === 85"
                                                color="primary"
                                                class="mt-2"
                                                @click="openIneUpdateRequest"
                                            >
                                                <v-icon left>{{info_invitation[0].ine_update_pending ? 'replay' : 'photo_camera'}}</v-icon>
                                                {{info_invitation[0].ine_update_pending ? 'Reenviar solicitud de actualización de fotos de INE' : 'Solicitar actualización de fotos de INE'}}
                                            </v-btn>
                                        </v-flex>
                                        <v-flex v-else class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="require('../../assets/sin-foto.png')"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                            <v-btn
                                                color="primary"
                                                class="mt-2"
                                                v-if="info_invitation.length > 0 && info_invitation[0].documentationByInvitation && info_invitation[0].documentationByInvitation.length > 0"
                                                :loading="loadingDocumentation"
                                                @click="showDocumentation()"
                                            >
                                                Ver Documentos Adjuntos
                                            </v-btn>
                                            <v-btn
                                                v-if="typeof info_invitation[0].ine_update_pending === 'boolean' && getProfile.id_company === 85"
                                                color="primary"
                                                class="mt-2"
                                                @click="openIneUpdateRequest"
                                            >
                                                <v-icon left>{{info_invitation[0].ine_update_pending ? 'replay' : 'photo_camera'}}</v-icon>
                                                {{info_invitation[0].ine_update_pending ? 'Reenviar solicitud de actualización de fotos de INE' : 'Solicitar actualización de fotos de INE'}}
                                            </v-btn>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Visitante')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].guestFirstName}}
                                                            {{ info_invitation[0].guestLastName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('celular')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].guestCellPhone}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.length > 0 && info_invitation[0].guestNameCompany !== null">
                                                    <th>
                                                        <h2>
                                                            {{$t('Empresa')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].guestNameCompany}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Area')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].areaName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.length > 0 && info_invitation[0].secEqu && info_invitation[0].secEqu.length > 0">
                                                    <th>
                                                        <h2>
                                                            {{$t('equipo_seguridad')}}
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h3>
                                                            <div v-if="info_invitation[0] && info_invitation[0].secEqu" v-for="(equipo, index) in info_invitation[0].secEqu" v-bind:key="equipo.index">
                                                                <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                            </div>
                                                        </h3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].asunto}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_inv')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].dateInv}}  {{ info_invitation[0].timeInv}}
                                                        </h2>
<!--                                                        <v-btn color="red"-->
<!--                                                               @click="setChangeHour(info_invitation[0].qr_code, info_invitation[0].timeInv)"-->
<!--                                                        >{{$t('modificar_hora')}}-->
<!--                                                        </v-btn>-->
                                                    </td>
                                                </tr>
                                                <tr v-show="vigente(this.fecha_actual, info_invitation[0].expiration) && !info_invitation[0].authorized">
                                                    <td colspan="2">
                                                        <h2>
                                                            {{$t('msg_acceso')}}:
                                                        </h2>
                                                        <v-btn
                                                                color="primary"
                                                                :loading="loadingNotifyAccess"
                                                                @click="notifyAccess(info_invitation[0].guestFirstName, info_invitation[0].guestLastName, info_invitation[0].id)"
                                                                dark>{{$t('notificar')}}
                                                            <v-icon dark right>check_circle</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.length > 0 && info_invitation[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('dias_validos')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('0') === true">
                                                            {{ $t('Lunes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('1') === true">
                                                            {{ $t('Martes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('2') === true">
                                                            {{ $t('Miercoles') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('3') === true">
                                                            {{ $t('Jueves') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('4') === true">
                                                            {{ $t('Viernes') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('5') === true">
                                                            {{ $t('Sabado') }}
                                                        </h2>
                                                        <h2 v-if="info_invitation.length > 0 && info_invitation[0].diary && info_invitation[0].diary.includes('6') === true">
                                                            {{ $t('Domingo') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.length > 0 && info_invitation[0].typeInv === 2">
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_expiracion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].expiration }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr v-if="info_invitation.length > 0">
                                                    <th>
                                                        <h2>
                                                            {{$t('Estado')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <v-chip v-if="info_invitation[0].confirmed === true" color="green" text-color="white">
                                                            <v-icon left>check_circle</v-icon>
                                                            {{$t('Aceptada')}}
                                                        </v-chip>
                                                        <v-chip v-else-if="info_invitation[0].declined === true" color="red" text-color="white">
                                                            <v-icon left>block</v-icon>
                                                            {{$t('Rechazada')}}
                                                        </v-chip>
                                                        <v-chip v-else color="orange" text-color="white">
                                                            <v-icon left>schedule</v-icon>
                                                            {{$t('Pendiente')}}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>{{$t('info_anfitrion')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="info_invitation[0].host_ine_frente"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <table id="datas" style="width:100%">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].hostFirstName}}
                                                            {{ info_invitation[0].hostLastName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>{{$t('celular')}}:</h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].host_celular}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>{{$t('Area')}}:</h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_invitation[0].areaName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogIneUpdateRequest" max-width="500">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Solicitud de actualización de fotos de INE</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon color="red" @click="dialogIneUpdateRequest = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div>Selecciona el canal para enviar la solicitud al invitado:</div>
                        <v-radio-group v-model="ineUpdateChannel" :mandatory="true">
                            <v-radio
                                v-for="channel in ineUpdateChannels"
                                :key="channel.value"
                                :label="channel.label"
                                :value="channel.value"
                            ></v-radio>
                        </v-radio-group>
                        <div v-if="ineUpdateChannels.length === 0" class="error--text">
                            El invitado no tiene celular ni correo registrado para recibir la solicitud.
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialogIneUpdateRequest = false">
                            {{$t('cancelar')}}
                        </v-btn>
                        <v-btn
                            color="primary"
                            :loading="loadingIneUpdateRequest"
                            :disabled="loadingIneUpdateRequest || ineUpdateChannels.length === 0 || !ineUpdateChannel"
                            @click="submitIneUpdateRequest"
                        >
                            {{info_invitation.length > 0 && info_invitation[0].ine_update_pending ? 'Reenviar solicitud' : 'Enviar solicitud'}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_detail_access" scrollable width="1000">
                <v-card color="blue-grey lighten-4" class="elevation-0">
                    <v-toolbar class="mb-0" dark color="primary">
                        <v-toolbar-title>
                            {{$t('detalle_access')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_detail_access = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div class="text-xs-center" v-if="info_access.length > 0">
                            <v-layout justify-center class="text-xs-center" row wrap>
                                <v-flex xs12>
                                    <h2>{{$t('info_invitado')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="info_access[0].guestIneFront"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Visitante')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].guestFName}}
                                                            {{ info_access[0].guestLName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('celular')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].guestCellphone}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            E-Mail:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].guestEmail}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Empresa')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].companyName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <!--                                                <tr>-->
                                                <!--                                                    <th>-->
                                                <!--                                                        <h2>-->
                                                <!--                                                            {{$t('equipo_seguridad')}}-->
                                                <!--                                                        </h2>-->
                                                <!--                                                    </th>-->
                                                <!--                                                    <td>-->
                                                <!--                                                        <h3>-->
                                                <!--                                                            <div v-for="(equipo, index) in equipo_por_invitacion" v-bind:key="equipo.index">-->
                                                <!--                                                                <h3>{{index + 1}} .- {{ equipo.name_equipamnet }}</h3>-->
                                                <!--                                                            </div>-->
                                                <!--                                                        </h3>-->
                                                <!--                                                    </td>-->
                                                <!--                                                </tr>-->
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Asunto')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].asunto}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Notas')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].notas === '' ? 'Sin notas' : info_access[0].notas }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>{{$t('info_anfitrion')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="info_access[0].hostIneFront"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <table id="datas" style="width:100%">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('Anfitrion')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].hostFirstName}}
                                                            {{ info_access[0].hostLastName}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>{{$t('celular')}}:</h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].hostCellphone}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>E-Mail:</h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].hostEmail}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>{{$t('Area')}}:</h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].nombreArea}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12>
                                    <h2>{{$t('info_acceso')}}</h2>
                                    <br>
                                    <v-layout align-center justify-center row wrap>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <v-img
                                                    :src="info_access[0].guestAvatar"
                                                    position="center center"
                                                    class="grey lighten-2"
                                            ></v-img>
                                        </v-flex>
                                        <v-flex class="text-xs-center" xs12 sm6>
                                            <table id="datas">
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('guardhouse_name_checkin')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].guardhouse_name_checkin === null ? 'N/A' : info_access[0].guardhouse_name_checkin}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_hora_acceso_in')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].fecha_hora_acceso}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('guardhouse_name_checkout')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].guardhouse_name_checkout === null ? 'N/A' : info_access[0].guardhouse_name_checkout}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('fecha_hora_acceso_out')}}:
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].fecha_hora_salida == null ? $t('pendiente')  : info_access[0].fecha_hora_salida }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('estado')}}
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2 v-if="info_access.length > 0 && info_access[0].estado === 1">
                                                            {{ $t('adentro') }}
                                                        </h2>
                                                        <h2 v-else-if="info_access.length > 0 && info_access[0].estado === 0">
                                                            {{ $t('completado') }}
                                                        </h2>
                                                        <h2 v-else>
                                                            {{ $t('deny') }}
                                                        </h2>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <h2>
                                                            {{$t('pase_salida')}}
                                                        </h2>
                                                    </th>
                                                    <td>
                                                        <h2>
                                                            {{ info_access[0].pase_salida === true ? $t('firmado') : $t('no_firmado')}}
                                                        </h2>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_accesos_without_code" scrollable max-width="800px">
                    <v-flex class="text-xs-center">
                        <v-card color="blue-grey lighten-4" class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog_accesos_without_code = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <div class="text-xs-center">
                                    <v-layout justify-center class="text-xs-center" row wrap>
                                        <v-flex xs12>
                                            <h2>{{$t('info_invitado')}}</h2>
                                            <br>
                                            <v-layout align-center justify-center row wrap>
                                                <v-flex class="text-xs-center" xs12 sm6>
                                                    <v-img
                                                            :src="data_accesos_without_code.url_foto"
                                                            position="center center"
                                                            class="grey lighten-2"
                                                    ></v-img>
                                                </v-flex>
                                                <v-flex class="text-xs-center" xs12 sm6>
                                                    <table id="datas">
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('Visitante')}}:
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.guest_full_name}}
                                                                </h2>
                                                            </td>
                                                        </tr>
<!--                                                        <tr>-->
<!--                                                            <th>-->
<!--                                                                <h2>-->
<!--                                                                    {{$t('celular')}}:-->
<!--                                                                </h2>-->
<!--                                                            </th>-->
<!--                                                            <td>-->
<!--                                                                <h2>-->
<!--                                                                    {{ data_accesos_without_code.telefono}}-->
<!--                                                                </h2>-->
<!--                                                            </td>-->
<!--                                                        </tr>-->
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('Empresa')}}:
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.company_name}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('Area')}}:
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.areaName}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('Notas')}}
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.notas}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('hora_acceso')}}
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.datetime_checkin}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('guardhouse_name_checkin')}}:
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.guardhouse_name_checkin === null ? 'N/A' : data_accesos_without_code.guardhouse_name_checkin}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('hora_salida')}}
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.datetime_checkout ? data_accesos_without_code.datetime_checkout : "Salida no registrada" }}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('guardhouse_name_checkout')}}:
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{ data_accesos_without_code.guardhouse_name_checkout === null ? 'N/A' :  data_accesos_without_code.guardhouse_name_checkout}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>
                                                                <h2>
                                                                    {{$t('Anfitrion')}}
                                                                </h2>
                                                            </th>
                                                            <td>
                                                                <h2>
                                                                    {{data_accesos_without_code.host_full_name}}
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-dialog>
            <v-dialog v-model="dialog_accesos_sin_codigo" scrollable max-width="800px">
                    <v-flex class="text-xs-center">
                        <v-card color="blue-grey lighten-4" class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog_accesos_sin_codigo = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <div class="text-xs-center">
                                    <v-layout justify-center class="text-xs-center" row wrap>
                                        <v-flex xs12>
                                            <h2>{{$t('info_invitado')}}</h2>
                                            <br>
                                            <v-layout align-center justify-center row wrap>
                                                <v-flex class="text-xs-center" xs12 sm6>
                                                    <v-img
                                                            :src="data_accesos_sin_codigo.url_foto"
                                                            position="center center"
                                                            class="grey lighten-2"
                                                    ></v-img>
                                                </v-flex>
                                                <v-flex class="text-xs-center" xs12 sm6>
                                                    <table id="datas">
                                                        <tr>
                                                            <th><h2>{{$t('Visitante')}}:</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.nombre}}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('Empresa')}}:</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.empresa}}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('Area')}}:</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.areaName}}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('Notas')}}</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.notas}}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('hora_acceso')}}</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.f_acceso}}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('hora_salida')}}</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.f_salida ? data_accesos_sin_codigo.f_salida : "Salida no registrada" }}</h2></td>
                                                        </tr>
                                                        <tr>
                                                            <th><h2>{{$t('Anfitrion')}}</h2></th>
                                                            <td><h2>{{ data_accesos_sin_codigo.host}}</h2></td>
                                                        </tr>
                                                    </table>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
            </v-dialog>
            <v-dialog v-model="dialog_assigned_detail" scrollable max-width="900px">
                <v-card color="blue-grey lighten-4" class="elevation-0" v-if="selected_assigned_invitation">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Detalle de {{ selected_assigned_invitation.chipText }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="red"
                            text
                            @click="dialog_assigned_detail = false"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap class="pa-3">
                            <!-- Foto del Empleado -->
                            <v-flex xs12 sm4 class="text-xs-center pa-2">
                                <h3 class="mb-3">Foto del Empleado</h3>
                                <div v-if="selected_assigned_invitation.employee_avatar" style="max-width: 250px; margin: 0 auto;">
                                    <img 
                                        :src="selected_assigned_invitation.employee_avatar"
                                        style="max-width: 100%; max-height: 300px; border-radius: 4px; object-fit: cover;"
                                        @error="(e) => e.target.style.display = 'none'"
                                    >
                                </div>
                                <div v-else style="width: 250px; height: 300px; background: #f0f0f0; border-radius: 4px; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
                                    <span style="color: #999; font-size: 14px;">Sin Foto</span>
                                </div>
                            </v-flex>

                            <!-- Información del Empleado -->
                            <v-flex xs12 sm8 class="pa-2">
                                <v-card class="mb-3 elevation-1">
                                    <v-card-title class="blue-grey lighten-5 py-2">
                                        <h3>Información del Empleado</h3>
                                    </v-card-title>
                                    <v-card-text>
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tbody>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold; width: 40%;">Nombre:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.employee_name }}</td>
                                                </tr>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">Email:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.employee_email }}</td>
                                                </tr>
                                                <tr>
                                                    <td style="padding: 8px; font-weight: bold;">Teléfono:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.employee_phone }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </v-card-text>
                                </v-card>

                                <!-- Información de la Invitación/Embarque -->
                                <v-card class="elevation-1">
                                    <v-card-title class="blue-grey lighten-5 py-2">
                                        <h3>{{ selected_assigned_invitation.type === 'shipment' ? 'Información del Embarque' : 'Información de la Invitación' }}</h3>
                                    </v-card-title>
                                    <v-card-text>
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tbody>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold; width: 40%;">{{ selected_assigned_invitation.type === 'shipment' ? 'Cliente' : 'Asunto' }}:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.subject }}</td>
                                                </tr>
                                                <tr v-if="selected_assigned_invitation.type !== 'shipment'" style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">Empresa:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.company_name }}</td>
                                                </tr>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">{{ selected_assigned_invitation.type === 'shipment' ? 'Área de Carga' : 'Área' }}:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.area_name }}</td>
                                                </tr>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">Fecha:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.date_invitation }} {{ selected_assigned_invitation.time_invitation }}</td>
                                                </tr>
                                                <tr style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">{{ selected_assigned_invitation.type === 'shipment' ? 'Ventana' : 'Vencimiento' }}:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.expiration_date }}</td>
                                                </tr>
                                                <tr v-if="selected_assigned_invitation.type !== 'shipment'" style="border-bottom: 1px solid #e0e0e0;">
                                                    <td style="padding: 8px; font-weight: bold;">Anfitrión:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.host_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td style="padding: 8px; font-weight: bold;">Notas:</td>
                                                    <td style="padding: 8px;">{{ selected_assigned_invitation.notes || '-' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <!-- Acciones -->
                            <v-flex xs12 class="pa-2">
                                <v-layout row justify-end>
                                    <v-btn
                                        color="primary"
                                        @click="downloadGafeteQR(selected_assigned_invitation)"
                                        :loading="loadingPdfGafete"
                                        class="mr-2"
                                    >
                                        <v-icon left>download</v-icon>
                                        Descargar Invitacion
                                    </v-btn>
                                    <v-btn
                                        color="error"
                                        @click="dialog_assigned_detail = false"
                                    >
                                        <v-icon left>close</v-icon>
                                        Cerrar
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-card-text>
                            <h3>{{$t('mostrando_historial_dia')}} </h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout class="align-center " row wrap>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedFinalDateFormatted"
                                                        prepend-icon="event"
                                                        name="date2"
                                                        :label="$t('Fecha_fin')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date2"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    v-model="date2"
                                                    @input="calendario2 = false, submit()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                                large
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>
                            <v-tabs
                                    v-model="activeTab"
                                    grow
                                    fixed-tabs
                                    color="transparent"
                                    slider-color="primary">
                                <v-tab>
                                    <v-icon left>inbox</v-icon>
                                    {{$t('recibidos')}}
                                </v-tab>
                                <v-tab v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-icon left>send</v-icon>
                                    {{$t('enviados')}}
                                </v-tab>
                                <v-tab v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-icon left>forward_to_inbox</v-icon>
                                    {{$t('shared')}}
                                </v-tab>
                                <v-tab v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-icon left>compare_arrows</v-icon>
                                    {{$t('Accesos')}}
                                </v-tab>
                                <v-tab>
                                    <v-icon left>pending_actions</v-icon>
                                    Pendientes
                                    <v-badge
                                        v-if="pendingAllInvitations.length > 0"
                                        color="red"
                                        :content="String(pendingAllInvitations.length)"
                                        overlap
                                        class="ml-1"
                                    ></v-badge>
                                </v-tab>
                                <v-tab-item>
                                    <v-data-table
                                            :headers="headersRecieved"
                                            :loading="loading_data_invitaciones_recibidas || loading_parking_reservations_received"
                                            :items="mappedInvitacionesRecibidasForRecibidos"
                                            item-key="uniqueId"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                        {text: '5', value: 5},
                                                        {text: '10', value: 10},
                                                        {text: '25', value: 25},
                                                        {text: this.$t('todos'), value: -1}]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_invit')"
                                    >
                                        <template v-slot:items="props">
                                            <td class="justify-center layout px-0">
                                                <v-icon
                                                        v-if="!props.item.isShipment && !props.item.isParkingData"
                                                        large
                                                        class="mr-2"
                                                        @click="props.item.chipText === 'Estacionamiento' ? get_detail_recibidas_park(props.item) : get_detail_recibidas(props.item.id)"
                                                >
                                                    search
                                                </v-icon>
                                                <v-icon
                                                        v-if="props.item.isShipment"
                                                        medium
                                                        color="blue"
                                                        @click="openDriversModal(props.item, false)"
                                                        title="Choferes"
                                                >
                                                    info
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-chip :color="props.item.chipColor" text-color="white" small>
                                                    {{ props.item.chipText }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip
                                                    label
                                                    :color="props.item.canceled === true ? 'error' : 'success'"
                                                    dark
                                                >
                                                  <v-icon left v-if="props.item.canceled">event_busy</v-icon>
                                                  <v-icon left v-else>event</v-icon>
                                                  {{props.item.canceled === true ? $t('canceled') : $t('current') }}
                                                </v-chip>
                                            </td>
                                            <td align="center" v-if="props.item.confirmed === true">{{ $t('Si') }}</td>
                                            <td align="center" v-else>No</td>
                                            <td align="center" v-if="props.item.multiple_accesses === true">{{ $t('Si') }}</td>
                                            <td align="center" v-else>No</td>
                                            <td>{{ formatDateDDMMYYYY(props.item.normalizedDate) }} {{ props.item.normalizedTime }}</td>
                                            <td>{{ props.item.normalizedHost }}</td>
                                            <td>{{ props.item.normalizedArea }}</td>
                                            <td>{{ props.item.normalizedSubject }}</td>
                                        </template>
                                        <template v-slot:pageText="props">
                                            <vue-excel-xlsx
                                                    :data="mappedInvitacionesRecibidasExport"
                                                    :columns="headersRecievedExcel"
                                                    :file-name="'invitationsRecibidas' + '_' + date + '_' + date2"
                                                    :sheet-name="$t('headerInvitationRecivedCompanyExcel')"
                                            >
                                                <v-btn color="primary" small>
                                                    {{$t('export_to_excel')}}
                                                </v-btn>
                                            </vue-excel-xlsx>
                                            <v-btn
                                                    color="primary"
                                                    small
                                                    @click="exportPdfInvitationInboxCompanies"
                                            >
                                                    {{$t('export_to_pdf')}}
                                            </v-btn>
                                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab-item v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-data-table
                                            :headers="headersSent"
                                            :loading="loading_data_invitaciones || loading_parking_reservations_sent"
                                            :items="mappedInvitaciones"
                                            item-key="uniqueId"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_invit')"
                                    >
                                        <template v-slot:items="props">
                                            <td align="center" class="justify-center layout px-0">
                                                <v-icon
                                                        v-if="!props.item.isShipment && !props.item.isParkingData"
                                                        medium
                                                        @click="get_detail(props.item.id)"
                                                >
                                                    search
                                                </v-icon>
                                                <v-icon
                                                        v-show="!props.item.canceled && !props.item.isShipment && !props.item.isParkingData"
                                                        medium
                                                        color="red"
                                                        @click="dialog_elimnar = true, id_invitacion_eliminar = props.item.id"
                                                >
                                                    event_busy
                                                </v-icon>
                                                <v-icon
                                                        v-if="props.item.isShipment"
                                                        medium
                                                        color="blue"
                                                        @click="openDriversModal(props.item, true)"
                                                        title="Choferes"
                                                >
                                                    info
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-chip :color="props.item.chipColor" text-color="white" small>
                                                    {{ props.item.chipText }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip
                                                    label
                                                    :color="props.item.canceled === true ? 'error' : 'success'"
                                                    dark
                                                >
                                                  <v-icon left v-if="props.item.canceled">
                                                    event_busy
                                                  </v-icon>
                                                  <v-icon left v-else>
                                                    event
                                                  </v-icon>
                                                  {{props.item.canceled === true ? $t('canceled') : $t('current') }}
                                                </v-chip>
                                            </td>
                                            <td align="center" v-if="props.item.confirmed === true">{{ $t('Si') }}</td>
                                            <td align="center" v-else>No</td>
                                            <td align="center" v-if="props.item.multiple_accesses === true">{{ $t('Si') }}</td>
                                            <td align="center" v-else>No</td>
                                            <td>{{ props.item.fechaEnvio}}</td>
                                            <td>{{ formatDateDDMMYYYY(props.item.normalizedDate) }} {{ props.item.normalizedTime }}</td>
                                            <td>{{ props.item.normalizedHost }}</td>
                                            <td>{{ props.item.normalizedGuest }}</td>
                                            <td>{{ props.item.normalizedArea }}</td>
                                            <td align="center">{{ props.item.automovil ? $t('Si') : "No" }}</td>
                                            <td align="center">
                                                <v-chip v-if="props.item.confirmed === true" color="green" text-color="white" small>
                                                    <v-icon left x-small>check_circle</v-icon>
                                                    {{$t('Aceptada')}}
                                                </v-chip>
                                                <v-chip v-else-if="props.item.declined === true" color="red" text-color="white" small>
                                                    <v-icon left x-small>block</v-icon>
                                                    {{$t('Rechazada')}}
                                                </v-chip>
                                                <v-chip v-else color="orange" text-color="white" small>
                                                    <v-icon left x-small>schedule</v-icon>
                                                    {{$t('Pendiente')}}
                                                </v-chip>
                                            </td>
                                            <td align="center" v-if="getProfile.enable_shipments">
                                                <v-chip v-if="props.item.is_external_invitation !== undefined" small :color="props.item.is_external_invitation ? 'warning' : 'grey'" text-color="white">{{ props.item.is_external_invitation ? $t('Si') : 'No' }}</v-chip>
                                                <span v-else>-</span>
                                            </td>
                                        </template>
                                        <template v-slot:pageText="props">
                                            <vue-excel-xlsx
                                                    :data="mappedInvitacionesExport"
                                                    :columns="headersSentExcel"
                                                    :file-name="'invitacionesEnviadas' + '_' + date + '_' + date2"
                                                    :sheet-name="$t('headerInvitationSentExcel')"
                                            >
                                                <v-btn color="primary" small>
                                                    {{$t('export_to_excel')}}
                                                </v-btn>
                                            </vue-excel-xlsx>
                                            <v-btn
                                                    color="primary"
                                                    small
                                                    @click="exportPdfInvitationSent"
                                            >
                                                    {{$t('export_to_pdf')}}
                                            </v-btn>
                                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab-item v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-data-table
                                            :headers="headersSent"
                                            :loading="loading_data_shared"
                                            :items="mappedInvitacionesShared"
                                            item-key="uniqueId"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_invit')"
                                    >
                                        <template v-slot:items="props">
                                            <td align="center" class="justify-center layout px-0">
                                                <v-icon
                                                        v-if="!props.item.isShipment"
                                                        medium
                                                        @click="get_detail(props.item.id)"
                                                >
                                                    search
                                                </v-icon>
                                                <v-icon
                                                        v-show="!props.item.canceled && !props.item.isShipment"
                                                        medium
                                                        color="red"
                                                        @click="dialog_elimnar = true, id_invitacion_eliminar = props.item.id"
                                                >
                                                    event_busy
                                                </v-icon>
                                                <v-icon
                                                        v-if="props.item.isShipment"
                                                        medium
                                                        color="blue"
                                                        @click="openDriversModal(props.item, false)"
                                                        title="Choferes"
                                                >
                                                    info
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-chip :color="props.item.chipColor" text-color="white" small>
                                                    {{ props.item.chipText }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip
                                                    label
                                                    :color="props.item.canceled === true ? 'error' : 'success'"
                                                    dark
                                                >
                                                  <v-icon left v-if="props.item.canceled">
                                                    event_busy
                                                  </v-icon>
                                                  <v-icon left v-else>
                                                    event
                                                  </v-icon>
                                                  {{props.item.canceled === true ? $t('canceled') : $t('current') }}
                                                </v-chip>
                                            </td>
                                            <td align="center">
                                                <v-chip v-if="props.item.confirmed === true" color="green" text-color="white" small>
                                                    <v-icon left x-small>check_circle</v-icon>
                                                    {{$t('Aceptada')}}
                                                </v-chip>
                                                <v-chip v-else-if="props.item.declined === true" color="red" text-color="white" small>
                                                    <v-icon left x-small>block</v-icon>
                                                    {{$t('Rechazada')}}
                                                </v-chip>
                                                <v-chip v-else color="orange" text-color="white" small>
                                                    <v-icon left x-small>schedule</v-icon>
                                                    {{$t('Pendiente')}}
                                                </v-chip>
                                            </td>
                                            <td align="center" v-if="props.item.multiple_accesses === true">{{ $t('Si') }}</td>
                                            <td align="center" v-else>No</td>
                                            <td>{{ props.item.fechaEnvio}}</td>
                                            <td>{{ formatDateDDMMYYYY(props.item.normalizedDate) }} {{ props.item.normalizedTime }}</td>
                                            <td>{{ props.item.normalizedHost }}</td>
                                            <td>{{ props.item.normalizedGuest }}</td>
                                            <td>{{ props.item.normalizedArea }}</td>
                                            <td align="center">{{ props.item.automovil ? $t('Si') : "No" }}</td>
                                            <td align="center" v-if="getProfile.enable_shipments">
                                                <v-chip v-if="props.item.is_external_invitation !== undefined" small :color="props.item.is_external_invitation ? 'warning' : 'grey'" text-color="white">{{ props.item.is_external_invitation ? $t('Si') : 'No' }}</v-chip>
                                                <span v-else>-</span>
                                            </td>
                                        </template>
                                        <template v-slot:pageText="props">
                                            <vue-excel-xlsx
                                                    :data="mappedInvitacionesSharedExport"
                                                    :columns="headersSentExcel"
                                                    :file-name="'invitacionesCompartidas' + '_' + date + '_' + date2"
                                                    :sheet-name="$t('headerInvitationSentExcel')"
                                            >
                                                <v-btn color="primary" small>
                                                    {{$t('export_to_excel')}}
                                                </v-btn>
                                            </vue-excel-xlsx>
                                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab-item v-if="getProfile.roll == 5 || getProfile.roll == 1">
                                    <v-data-table
                                            :headers="headersAccess2"
                                            :loading="loading_data_access2"
                                            :items="access"
                                            :rows-per-page-text="$t('filas_por_pagina')"
                                            :rows-per-page-items="[
                                                        {text: '5', value: 5},
                                                        {text: '10', value: 10},
                                                        {text: '25', value: 25},
                                                        {text: this.$t('todos'), value: -1}]"
                                            class="elevation-1"
                                            :no-data-text="$t('no_registros_accesos')"
                                    >
                                        <template v-slot:items="props">
                                            <td v-if="props.item.access_qr_code === true && props.item.contractor === false" class="justify-center layout px-0">
                                                <v-icon
                                                        large
                                                        class="mr-2"
                                                        @click="get_access_detail(props.item.id)"
                                                >
                                                    search
                                                </v-icon>
                                                <v-tooltip
                                                    v-if="props.item.download !== null"
                                                    bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="success"
                                                        @click="fillTransportFields(props.item), accessQRCode = props.item.access_qr_code, idAccess= props.item.id, accessContractor = props.item.contractor, dialogTransport = true"
                                                    >
                                                      local_shipping
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('show_carrier_data')}}</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                        v-if="props.item.motivo_no_firma === null || props.item.motivo_no_firma === ''"
                                                        bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="primary"
                                                        @click="dialogComments = true, comments= '', bandAddComments = true,
                                                        id_acceso = props.item.id, idGuest = props.item.idGuest,
                                                        bandVeto = props.item.vetado"
                                                    >
                                                      add_comment
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('add_comments')}}</span>
                                                </v-tooltip>
                                                <v-tooltip v-else bottom>
                                                  <template v-slot:activator="{ on }">
                                                <v-icon
                                                        large
                                                        v-on="on"
                                                        color="warning"
                                                        @click="dialogComments = true, bandAddComments = false, comments=props.item.motivo_no_firma, id_acceso = props.item.id"
                                                >
                                                    feedback
                                                </v-icon>
                                                  </template>
                                                  <span>{{$t('comments')}}</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                    v-if="props.item.placas !== null"
                                                    bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="primary"
                                                        @click="imagenPlacas = props.item.placas, dialogShowPlacas = true"
                                                    >
                                                      photo_camera
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('placas_mostrar')}}</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                    v-if="props.item.vetado === true"
                                                    bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="error"
                                                    >
                                                      no_accounts
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('user_banned')}}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-else-if="props.item.access_qr_code === true && props.item.contractor === true" class="justify-center layout px-0">
                                                <v-icon
                                                        large
                                                        class="mr-2"
                                                        @click="fill_fields(props.item),
                                                                        dialog_accesos_without_code = true"
                                                >
                                                    search
                                                </v-icon>
                                                <v-tooltip
                                                    v-if="props.item.download !== null"
                                                    bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="success"
                                                        @click="fillTransportFields(props.item), accessQRCode = props.item.access_qr_code, accessContractor = props.item.contractor, idAccess= props.item.id, dialogTransport = true"
                                                    >
                                                      local_shipping
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('show_carrier_data')}}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-else class="justify-center layout px-0">
                                                <v-icon
                                                        large
                                                        class="mr-2"
                                                        @click="fill_fields(props.item),
                                                                        dialog_accesos_without_code = true"
                                                >
                                                    search
                                                </v-icon>
                                                <v-tooltip
                                                    v-if="props.item.download !== null"
                                                    bottom
                                                >
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon
                                                        large
                                                        v-on="on"
                                                        color="success"
                                                        @click="fillTransportFields(props.item), accessQRCode = props.item.access_qr_code, accessContractor = props.item.contractor, idAccess= props.item.id, dialogTransport = true"
                                                    >
                                                      local_shipping
                                                    </v-icon>
                                                  </template>
                                                  <span>{{$t('show_carrier_data')}}</span>
                                                </v-tooltip>
                                            </td>
                                            <td>{{ props.item.access_qr_code === true ? $t('acceso_con_codigo')  :  $t('acceso_sin_codigo') }}</td>
                                            <td>{{ props.item.guest_full_name }}</td>
                                            <td>{{ (props.item.company_name === null || props.item.company_name === '') ? 'n/a' : props.item.company_name}}</td>
<!--                                            <td>{{ props.item.health_survey ? props.item.temperature : 'n/a' }}</td>-->
                                            <td>
<!--                                              <v-alert-->
<!--                                                  class="mr-2"-->
<!--                                                  v-show="props.item.status === 0"-->
<!--                                                  type="info">-->
<!--                                                {{$t('pending_authorization')}}-->
<!--                                              </v-alert>-->

                                              <v-btn
                                                  v-show="props.item.status === 0 && props.item.authorized === false"
                                                  block
                                                  color="primary"
                                                  :loading="loadingNotifyAccess"
                                                  @click="notifyAccessNoCode(props.item.id, props.item.guest_full_name)"
                                                  dark
                                              >{{$t('authorize')}}
                                                <v-icon dark right>check_circle</v-icon>
                                              </v-btn>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 0 && props.item.authorized === true"
                                                  type="info">
                                                {{$t('authorized_access')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 1"
                                                  type="success">
                                                {{$t('adentro')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 2 && props.item.exit_pass === true"
                                                  type="info">
                                                {{$t('completado')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 2 && props.item.exit_pass === false"
                                                  type="warning">
                                                {{$t('no_firmado')}}/
                                                {{$t('completado')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 3"
                                                  type="warning">
                                                {{$t('no_firmado')}}/
                                                {{$t('completado')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 4"
                                                  type="error">
                                                {{$t('deny')}}
                                              </v-alert>
                                              <v-alert
                                                  class="mr-2"
                                                  v-show="props.item.status === 5"
                                                  type="info">
                                                {{$t('waiting_room')}}
                                              </v-alert>
                                            </td>
                                            <td>{{ formatDateDDMMYYYY(props.item.datetime_arrival) }}</td>
                                            <td>{{ props.item.datetime_checkin === null ? $t('pendiente') : formatDateDDMMYYYY(props.item.datetime_checkin) }}</td>
                                            <td>{{ props.item.datetime_checkout === null ? $t('pendiente')  : formatDateDDMMYYYY(props.item.datetime_checkout) }}</td>
                                            <td>{{ props.item.host_full_name}}</td>
                                        </template>
                                        <template v-slot:pageText="props">
                                            {{props.rowsPerPage}}
                                                    <vue-excel-xlsx
                                                            :data="accessForExcel"
                                                            :columns="headersAccessExcel"
                                                            :file-name="'access' + '_' + date + '_' + date2"
                                                            :sheet-name="$t('headerAccessExcel')"
                                                    >
                                                        <v-btn
                                                            color="primary"
                                                        >
                                                            {{$t('export_to_excel')}}
                                                        </v-btn>
                                                    </vue-excel-xlsx>
                                                    <v-btn
                                                            color="primary"
                                                            @click="exportPdfAccessUnion"
                                                    >
                                                            {{$t('export_to_pdf')}}
                                                    </v-btn>
                                            {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-data-table
                                        :headers="headersPendingAll"
                                        :loading="loading_data_invitaciones_recibidas || loading_parking_reservations_received"
                                        :items="pendingAllInvitations"
                                        item-key="uniqueId"
                                        :rows-per-page-text="$t('filas_por_pagina')"
                                        :rows-per-page-items="[
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}]"
                                        class="elevation-1"
                                        :no-data-text="$t('no_registros_invit')"
                                    >
                                        <template v-slot:items="props">
                                            <td class="justify-center layout px-0">
                                                <!-- Embarques: navegar al formulario de ventana -->
                                                <v-tooltip v-if="props.item.isShipment && props.item.token" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon medium color="primary" v-on="on"
                                                            @click="goToShippingForm(props.item.token)">
                                                            open_in_new
                                                        </v-icon>
                                                    </template>
                                                    <span>Completar invitación de embarque</span>
                                                </v-tooltip>
                                                <!-- Invitaciones Empresariales: Completar formulario -->
                                                <v-tooltip v-else-if="props.item.chipText === 'Invitación Empresarial' && props.item.Token" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon medium color="orange" v-on="on"
                                                            @click="goToEnterpriseForm(props.item.Token)">
                                                            open_in_new
                                                        </v-icon>
                                                    </template>
                                                    <span>Completar invitación empresarial</span>
                                                </v-tooltip>
                                                <!-- Invitaciones Normales: Ver detalle -->
                                                <v-tooltip v-else-if="props.item.chipText === 'Invitación Normal'" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon medium color="blue" v-on="on"
                                                            @click="get_detail_recibidas(props.item.invitation_id || props.item.id)">
                                                            search
                                                        </v-icon>
                                                    </template>
                                                    <span>Ver detalle de invitación normal</span>
                                                </v-tooltip>
                                                <!-- Empresa Normal / Recurrente: abrir detalle -->
                                                <v-tooltip v-else-if="!props.item.isShipment && !props.item.isParkingData && (props.item.chipText === 'Empresa Normal' || props.item.chipText === 'Empresa Recurrente')" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon medium color="blue" v-on="on"
                                                            @click="get_detail_recibidas(props.item.id)">
                                                            search
                                                        </v-icon>
                                                    </template>
                                                    <span>Ver detalle</span>
                                                </v-tooltip>
                                                <!-- Estacionamiento (API vieja): abrir detalle -->
                                                <v-tooltip v-else-if="!props.item.isShipment && !props.item.isParkingData && props.item.chipText === 'Estacionamiento'" bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon medium color="green" v-on="on"
                                                            @click="get_detail_recibidas_park(props.item)">
                                                            search
                                                        </v-icon>
                                                    </template>
                                                    <span>Ver detalle</span>
                                                </v-tooltip>
                                                <!-- Estacionamiento nueva API: solo informativo -->
                                                <v-icon v-else-if="props.item.isParkingData" medium color="grey">info</v-icon>
                                            </td>
                                            <td>
                                                <v-chip :color="props.item.chipColor" text-color="white" small>
                                                    {{ props.item.chipText }}
                                                </v-chip>
                                            </td>
                                            <td>{{ formatDateDDMMYYYY(props.item.normalizedDate) }} {{ props.item.normalizedTime }}</td>
                                            <td>{{ props.item.normalizedHost }}</td>
                                            <td>{{ props.item.normalizedArea || props.item.normalizedSubject }}</td>
                                            <td>
                                                <!-- Embarques: mostrar status de la ventana -->
                                                <v-chip v-if="props.item.isShipment" small color="orange" text-color="white">
                                                    {{ props.item.shipping_window_detail ? props.item.shipping_window_detail.status : 'PROGRAMADA' }}
                                                </v-chip>
                                                <!-- Parking pendiente referido -->
                                                <v-chip v-else-if="props.item.isParkingPendingReferred" small color="grey" text-color="white">
                                                    Referido pendiente
                                                </v-chip>
                                                <!-- Resto: sin confirmar -->
                                                <v-chip v-else small color="blue" text-color="white">
                                                    Sin confirmar
                                                </v-chip>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab v-if="getProfile.roll == 5 || getProfile.roll == 1 || getProfile.roll == 15">
                                    <v-icon left>group</v-icon>
                                    Asignadas a Empleados
                                    <v-badge
                                        v-if="mappedAssignedInvitations.length > 0"
                                        color="blue"
                                        :content="String(mappedAssignedInvitations.length)"
                                        overlap
                                        class="ml-1"
                                    ></v-badge>
                                </v-tab>
                                <v-tab-item v-if="getProfile.roll == 5 || getProfile.roll == 1 || getProfile.roll == 15">
                                    <v-card class="elevation-0 my-3 pa-3">
                                        <v-layout row wrap>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    v-model="search_assigned_employee"
                                                    prepend-icon="search"
                                                    placeholder="Buscar por nombre o email del empleado"
                                                    @keyup="get_assigned_invitations(); get_assigned_shipments()"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-select
                                                    v-model="filter_assigned_confirmed"
                                                    :items="[
                                                        { text: 'Todas', value: null },
                                                        { text: 'Confirmadas', value: true },
                                                        { text: 'Pendientes', value: false }
                                                    ]"
                                                    label="Estado"
                                                    @input="get_assigned_invitations(); get_assigned_shipments()"
                                                ></v-select>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                    <v-data-table
                                        :headers="headersAssignedInvitations"
                                        :loading="loading_assigned_invitations || loading_assigned_shipments"
                                        :items="mappedAssignedInvitations"
                                        item-key="uniqueId"
                                        :rows-per-page-text="$t('filas_por_pagina')"
                                        :rows-per-page-items="[
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}]"
                                        class="elevation-1"
                                        :no-data-text="'No hay invitaciones o embarques asignados'"
                                    >
                                        <template v-slot:items="props">
                                            <td align="center">
                                                <v-chip small :color="props.item.chipColor" text-color="white">
                                                    {{ props.item.chipText }}
                                                </v-chip>
                                            </td>
                                            <td class="justify-center layout px-0">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon
                                                            medium
                                                            color="blue"
                                                            v-on="on"
                                                            @click="openAssignedInvitationDetail(props.item)"
                                                        >
                                                            info
                                                        </v-icon>
                                                    </template>
                                                    <span>Ver detalle e información</span>
                                                </v-tooltip>
                                            </td>
                                            <td>{{ props.item.employee_name }}</td>
                                            <td>{{ props.item.employee_email }}</td>
                                            <td>{{ props.item.employee_phone }}</td>
                                            <td>{{ props.item.subject }}</td>
                                            <td>{{ props.item.company_name }}</td>
                                            <td>{{ props.item.area_name }}</td>
                                            <td>{{ props.item.date_invitation }} {{ props.item.time_invitation }}</td>
                                            <td>{{ props.item.expiration_date }}</td>
                                            <td align="center">{{ props.item.vehicle_required ? $t('Si') : 'No' }}</td>
                                            <td align="center">{{ props.item.multiple_accesses ? $t('Si') : 'No' }}</td>
                                            <td align="center">
                                                <v-chip v-if="props.item.confirmed" small color="success" text-color="white">
                                                    {{ $t('Si') }}
                                                </v-chip>
                                                <v-chip v-else small color="grey" text-color="white">
                                                    No
                                                </v-chip>
                                            </td>
                                            <td align="center">
                                                <v-chip v-if="props.item.authorized" small color="success" text-color="white">
                                                    {{ $t('Si') }}
                                                </v-chip>
                                                <v-chip v-else small color="grey" text-color="white">
                                                    No
                                                </v-chip>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                            </v-tabs>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="getProfile.roll == 5 || getProfile.roll == 15">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('invEmpRecurrentes')}}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-data-table
                                    :headers="headersRecurrentEnterpriseInvitations"
                                    :loading="loadingRecurrentEnterpriseInvitations"
                                    :items="recurrentEnterpriseInvitations"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_invit')"
                            >
                                <template v-slot:items="props">
                                    <td class="justify-center layout px-0">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        medium
                                                        class="mr-2"
                                                        v-on="on"
                                                        @click="dialogChangeGuest = true, qrCode = props.item.qr_code, email = '', entries = [], get_info_invitation()"
                                                >
                                                    edit
                                                </v-icon>
                                            </template>
                                            <span>{{$t('cambiar_empleado_asignado')}}</span>
                                        </v-tooltip>
                                    </td>
                                    <td>{{ formatDateDDMMYYYY(props.item.dateInv) }} {{ props.item.timeInv }}</td>
                                    <td>{{ props.item.expiration }}</td>
                                    <td>{{ props.item.hostName }}</td>
                                    <td>{{ props.item.companyName }}</td>
                                    <td>{{ props.item.areaName }}</td>
                                    <td>{{ props.item.subject }}</td>
                                </template>

                                <template v-slot:pageText="props">
                                    <!--                                                    <vue-excel-xlsx-->
                                    <!--                                                            :data="invitaciones_recibidas"-->
                                    <!--                                                            :columns="headersRecievedExcel"-->
                                    <!--                                                            :file-name="'invitationsInboxCompanies' + '_' + date + '_' + date2"-->
                                    <!--                                                            :sheet-name="$t('headerInvitationRecivedCompanyExcel')"-->
                                    <!--                                                    >-->
                                    <!--                                                        <v-btn-->
                                    <!--                                                            color="primary"-->
                                    <!--                                                        >-->
                                    <!--                                                            {{$t('export_to_excel')}}-->
                                    <!--                                                        </v-btn>-->
                                    <!--                                                    </vue-excel-xlsx>-->
                                    <!--                                                    <v-btn-->
                                    <!--                                                            color="primary"-->
                                    <!--                                                            @click="exportPdfInvitationInboxCompanies"-->
                                    <!--                                                    >-->
                                    <!--                                                            {{$t('export_to_pdf')}}-->
                                    <!--                                                    </v-btn>-->
                                    {{props.rowsPerPage}}
                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Modals para Choferes y Reasignación -->
<v-dialog v-model="dialogDrivers" max-width="520px">
              <v-card>
                <v-card-title class="blue darken-3 white--text py-3 px-4">
                  <span class="subheading">Conductores Asignados</span>
                  <v-spacer></v-spacer>
                  <v-btn icon dark small @click="dialogDrivers = false">
                    <v-icon small>close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                  <div v-if="selectedInvitation && selectedInvitation.assigned_drivers && selectedInvitation.assigned_drivers.length > 0">
                    <div
                      v-for="(driver, index) in selectedInvitation.assigned_drivers"
                      :key="`driver-${driver.id}-${index}`"
                    >
                      <div class="d-flex align-center justify-space-between px-4 py-3">
                        <div>
                          <div class="body-2 font-weight-medium">{{ driver.first_name }} {{ driver.last_name }}</div>
                          <div class="caption grey--text">{{ driver.email }}</div>
                          <div class="caption mt-1">
                            <span v-if="driver.canceled" class="error--text">Cancelado</span>
                            <span v-else-if="driver.confirmed" class="success--text">Confirmado</span>
                            <span v-else class="orange--text">Pendiente</span>
                            <span v-if="driver.arrival_registered" class="grey--text"> · Llegada registrada</span>
                            <span v-if="getProfile.enable_advanced_shipments" class="grey--text"> · {{ driver.is_internal ? 'Interno' : 'Externo' }}</span>
                            <span v-if="driver.vehicle_plate && getProfile.enable_advanced_shipments" class="grey--text"> · {{ driver.vehicle_plate }}</span>
                          </div>
                        </div>
                        <div class="d-flex align-center" style="gap:4px; flex-shrink:0;">
                          <v-progress-circular v-if="reassignIsLoading && !allCompanyEmployees.length" indeterminate color="primary" size="18"></v-progress-circular>
                          <template v-else-if="driver.is_internal && getProfile.enable_advanced_shipments && !driver.canceled && canReassignDrivers">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon small depressed color="primary" @click="openReasignVehicleModal(driver)">
                                  <v-icon small>directions_car</v-icon>
                                </v-btn>
                              </template>
                              <span>Reasignar Vehículo</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon small depressed color="orange darken-1" dark @click="openReleaseDriverModal(driver)">
                                  <v-icon small>person_remove</v-icon>
                                </v-btn>
                              </template>
                              <span>Liberar Chofer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon small depressed color="error" @click="openCancelAssignmentModal(driver)">
                                  <v-icon small>cancel</v-icon>
                                </v-btn>
                              </template>
                              <span>Cancelar Asignación</span>
                            </v-tooltip>
                          </template>
                          <!-- Botón legacy con estilo redondo 'rounded' -->
                          <v-btn v-else-if="!driver.canceled && !driver.arrival_registered && canReassignDrivers && isEmployee(driver)" color="warning" x-small rounded depressed @click="openReassignModal(driver)">Reasignar</v-btn>
                          <v-tooltip bottom v-else-if="!driver.canceled && !driver.arrival_registered && (!canReassignDrivers || !isEmployee(driver))">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon small disabled>
                                <v-icon small color="grey lighten-1">lock</v-icon>
                              </v-btn>
                            </template>
                            <span v-if="!canReassignDrivers">Solo el administrador transportista puede reasignar</span>
                            <span v-else>Este conductor no pertenece a tu empresa</span>
                          </v-tooltip>
                        </div>
                      </div>
                      <v-divider v-if="index + 1 < selectedInvitation.assigned_drivers.length"></v-divider>
                    </div>
                  </div>
                  <div v-else class="text-xs-center py-6 grey--text caption">
                    No hay conductores asignados.
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="blue darken-3" @click="dialogDrivers = false">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- REQ-007: Modal para Liberar Chofer -->
            <v-dialog v-model="dialogReleaseDriver" max-width="500px" persistent>
              <v-card class="rounded-xl overflow-hidden">
                <v-toolbar flat color="orange" dark>
                  <v-icon left>person_remove</v-icon>
                  <v-toolbar-title class="font-weight-bold">Liberar Chofer</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogReleaseDriver = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-6">
                  <div v-if="selectedDriver" class="mb-4">
                    <v-card flat color="orange lighten-5" class="mb-4 pa-3 rounded-lg">
                      <div class="d-flex align-center">
                        <v-icon color="orange" class="mr-3">info</v-icon>
                        <div>
                          <div class="caption orange--text font-weight-bold">Chofer a Liberar</div>
                          <div class="subheading font-weight-bold">{{ selectedDriver.first_name }} {{ selectedDriver.last_name }}</div>
                        </div>
                      </div>
                    </v-card>
                    <v-textarea
                      v-model="releaseReason"
                      label="Motivo de liberación"
                      outlined
                      prepend-icon="description"
                      rows="3"
                      placeholder="Cambio de disponibilidad, cambio de programación, etc."
                    ></v-textarea>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4 bg-light">
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" text @click="dialogReleaseDriver = false">Cancelar</v-btn>
                  <v-btn color="orange" depressed :loading="loadingAssignmentAction" :disabled="!releaseReason.trim()" @click="submitReleaseDriver" class="px-6">
                    <v-icon left>person_remove</v-icon>
                    Liberar Chofer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- REQ-007: Modal para Reasignar Vehículo -->
            <v-dialog v-model="dialogReassignVehicle" max-width="500px" persistent>
              <v-card class="rounded-xl overflow-hidden">
                <v-toolbar flat color="primary" dark>
                  <v-icon left>directions_car</v-icon>
                  <v-toolbar-title class="font-weight-bold">Reasignar Vehículo</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogReassignVehicle = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-6">
                  <div v-if="selectedDriver" class="mb-4">
                    <v-card flat color="blue lighten-5" class="mb-4 pa-3 rounded-lg">
                      <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-3">person</v-icon>
                        <div>
                          <div class="caption primary--text font-weight-bold">Chofer</div>
                          <div class="subheading font-weight-bold">{{ selectedDriver.first_name }} {{ selectedDriver.last_name }}</div>
                        </div>
                      </div>
                    </v-card>
                    <v-divider class="mb-4"></v-divider>
                    <div class="mb-4">
                      <div class="caption grey--text font-weight-bold">Vehículo Actual</div>
                      <v-chip color="grey lighten-3" class="mt-2">
                        <v-icon left small>directions_car</v-icon>
                        {{ (selectedDriver.vehicle && selectedDriver.vehicle.license_plate) || 'Sin vehículo' }}
                      </v-chip>
                    </div>
                    <v-autocomplete
                      v-model="selectedNewVehicle"
                      :items="filteredAvailableVehicles"
                      item-text="license_plate"
                      item-value="id"
                      label="Seleccionar nuevo vehículo"
                      outlined
                      prepend-icon="directions_car"
                      :loading="loadingVehicles"
                      return-object
                    >
                      <template v-slot:item="data">
                        <div class="d-flex align-center">
                          <span>{{ data.item.license_plate }}</span>
                          <span class="ml-2 caption grey--text">({{ data.item.type }} - {{ data.item.capacity_tonnage }}t)</span>
                        </div>
                      </template>
                      <template v-slot:selection="data">
                        <span>{{ data.item.license_plate }}</span>
                      </template>
                    </v-autocomplete>
                    <v-textarea
                      v-model="reassignVehicleReason"
                      label="Motivo de reasignación"
                      outlined
                      prepend-icon="description"
                      rows="3"
                      placeholder="Vehículo averiado, cambio de ruta, etc."
                    ></v-textarea>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4 bg-light">
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" text @click="dialogReassignVehicle = false">Cancelar</v-btn>
                  <v-btn color="primary" depressed :loading="loadingAssignmentAction" :disabled="!selectedNewVehicle || !reassignVehicleReason.trim()" @click="submitReassignVehicle" class="px-6">
                    <v-icon left>directions_car</v-icon>
                    Reasignar Vehículo
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- REQ-007: Modal para Cancelar Asignación -->
            <v-dialog v-model="dialogCancelAssignment" max-width="500px" persistent>
              <v-card class="rounded-xl overflow-hidden">
                <v-toolbar flat color="error" dark>
                  <v-icon left>cancel</v-icon>
                  <v-toolbar-title class="font-weight-bold">Cancelar Asignación</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogCancelAssignment = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-6">
                  <div v-if="selectedDriver" class="mb-4">
                    <v-card flat color="red lighten-5" class="mb-4 pa-3 rounded-lg">
                      <div class="d-flex align-center">
                        <v-icon color="error" class="mr-3">warning</v-icon>
                        <div>
                          <div class="caption error--text font-weight-bold">Cancelar Asignación</div>
                          <div class="subheading font-weight-bold">{{ selectedDriver.first_name }} {{ selectedDriver.last_name }}</div>
                        </div>
                      </div>
                    </v-card>
                    <v-alert type="warning" outlined icon="warning" class="mb-4">
                      <strong>Atención:</strong> Esta acción no se puede deshacer. El chofer será notificado.
                    </v-alert>
                    <v-textarea
                      v-model="cancellationReason"
                      label="Motivo de cancelación"
                      outlined
                      prepend-icon="description"
                      rows="3"
                      placeholder="Cambio de programación, servicio cancelado, etc."
                    ></v-textarea>
                    <v-checkbox
                      v-model="sendCancellationNotification"
                      label="Notificar al chofer"
                      class="mt-4"
                      color="primary"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4 bg-light">
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" text @click="dialogCancelAssignment = false">Mantener Asignación</v-btn>
                  <v-btn color="error" depressed :loading="loadingAssignmentAction" :disabled="!cancellationReason.trim()" @click="submitCancelAssignment" class="px-6">
                    <v-icon left>cancel</v-icon>
                    Cancelar Asignación
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Modal para Reasignar Chofer -->
            <v-dialog v-model="dialogReassign" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Reasignar Chofer</span>
                </v-card-title>
                <v-card-text>
                  <v-form ref="formReassign" v-model="validReassign" lazy-validation>
                    <v-autocomplete
                        v-model="selectedReassignEmployee"
                        :items="reassignItems"
                        :loading="reassignIsLoading"
                        :search-input.sync="reassignSearch"
                        return-object
                        item-text="email"
                        item-value="email"
                        label="Buscar chofer por nombre o correo"
                        placeholder="Escribe al menos 3 caracteres..."
                        prepend-icon="person_search"
                        no-data-text="Sin resultados"
                        clearable
                        :rules="[v => !!v || 'Selecciona un empleado']"        
                    >
                        <template v-slot:selection="data">
                            <v-chip :selected="data.selected" class="chip--select-multi">
                                {{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }} ({{ data.item.id_usuario.email }})
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <v-list-tile-avatar>
                                <v-icon color="grey">person</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{ data.item.id_usuario.email }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </v-autocomplete>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="closeReassignModal">Cancelar</v-btn>
                  <v-btn color="blue darken-1" flat :disabled="!selectedReassignEmployee || loadingReassign" :loading="loadingReassign" @click="submitReassign">Confirmar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import {mapGetters, mapState} from 'vuex'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'

    export default {
        name: "historial",
        data() {
            return {
            activeTab: null,
            alerta: false,
            calendario: false,
            calendario2: false,
            fecha_actual: '',
            date: '',
            date2: '',
            errores: [],
            search: '',
            headersSent: [],
            headersAccess: [],
            headersAccess2: [],
            headersAccessExcel: [],
            headersAccessNoCodeExcel: [],
            headersRecieved: [],
            headersRecievedExcel: [],
            headersRecievedExcelPark: [],
            headersSentExcel: [],
            headersRecievedPark: [],
            headersAccessNoCode: [],
            invitaciones:[],
            invitaciones_shared:[],
            invitaciones_recibidas:[],
            invitaciones_recibidas_park:[],
            accesos: [],
            access: [],
            accesos_without_code: [],
            loading_data_invitaciones: false,
            loading_data_shared: false,
            loading_data_invitaciones_recibidas: false,
            loading_data_invitaciones_recibidas_park: false,
            loading_parking_received: false,
            loading_parking_sent: false,
            loading_parking_reservations_received: false,
            loading_parking_reservations_sent: false,
            loading_data_accesos: false,
            loading_data_access2: false,
            loading_data_accesos_without_code: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            parking_invitations_received: [],
            parking_invitations_sent: [],
            parking_reservations_received: [],
            parking_reservations_sent: [],
            dialog_detail_invit: false,
            dialogIneUpdateRequest: false,
            ineUpdateChannel: null,
            loadingIneUpdateRequest: false,
            dialog_detail_invit_recibidas: false,
            dialog_detail_invit_recibidas_park: false,
            info_invitation: [],
            info_invitation_recibida: [],
            info_invitation_recibida_park: [],
            dialog_detail_access: false,
            dialog_accesos_without_code: false,
            info_access: [],
            dialog_elimnar: false,
            id_invitacion_eliminar: '',
            loading_si: false,
            loading_no: false,
            data_accesos_without_code: [],
            dialog_accesos_sin_codigo: false,
            data_accesos_sin_codigo: {},
            // Variables para modificar la Hora  de la Invitación
            dialog_changeHour: false,
            hora: '',
            menu: '',
            qr_code_changeHour: '',
            loadingNotifyAccess: false,
            email: '',
            isLoading: false,
            entries: [],
            dialogChangeGuest: false,
            loadingRecurrentEnterpriseInvitations: false,
            recurrentEnterpriseInvitations: [],
            headersRecurrentEnterpriseInvitations: [],
            loadingChangeGuest: false,
            qrCode: 0,
            dataQR: '',
            dialogComments: false,
            dialogDrivers: false,
            selectedInvitation: null,
            dialogReassign: false,
            validReassign: false,
            loadingReassign: false,
            reassignForm: {
                old_qr_code: '',
                new_guest_email: ''
            },
            selectedReassignEmployee: null,
            reassignSearch: '',
            reassignItems: [],
            allCompanyEmployees: [],
            canReassignDrivers: false,
            reassignIsLoading: false,
            emailRules: [
                v => !!v || 'El correo es requerido',
                v => /.+@.+\..+/.test(v) || 'El correo debe tener un formato válido'
            ],
            id_acceso: '',
            idGuest: '',
            comments: '',
            bandAddComments: true,
            bandVeto: true,
            dialogShowPlacas: false,
            dialogVeto: false,
            tipo: null,
            motivo: '',
            modalFechaInicial: false,
            modalFechaFinal: false,
            fecha_inicial:'',
            fecha_final: '',
            typeService: null,
            case_plates: '',
            container_platform_plates: '',
            transport_line: '',
            supplier_customer_name: '',
            imagenPlacas: '',
            accessQRCode: false,
            accessContractor: false,
            bandConfirm: false,
            loading: false,
            idAccess: '',
            dialogTransport: false,
            dialogDocumentos: false,
            dialogDocumentationCorrection: false,
            selectedDocument: [],
            loadingDocumentsCorrection: false,
            faltaArchivo: false,
            dialogShowDocument: false,
            fileUrl: '',
            isPdf: false,
            missingDocumentations: [],
            loadingDocumentation: false,
            idUserByInvitation: 0,
            ineFront: {
                "id": 1000,
                "name": "INE Frente",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
            ineBack: {
                "id": 1001,
                "name": "INE Reverso",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
            enterprise_invitations: [],
            normal_invitations: [],
            loading_enterprise_invitations: false,
            loading_normal_invitations: false,
            assigned_invitations: [],
            loading_assigned_invitations: false,
            search_assigned_employee: '',
            filter_assigned_confirmed: null,
            dialog_assigned_detail: false,
            selected_assigned_invitation: null,
            loadingPdfGafete: false,
            assigned_shipments: [],
            loading_assigned_shipments: false,
            // REQ-007: Campos para gestión de asignaciones internas
            selectedDriver: null,
            dialogReleaseDriver: false,
            dialogReassignVehicle: false,
            dialogCancelAssignment: false,
            releaseReason: '',
            reassignVehicleReason: '',
            cancellationReason: '',
            sendCancellationNotification: true,
            loadingAssignmentAction: false,
            selectedNewVehicle: '',
            availableVehicles: [],
            loadingVehicles: false
            }
        },
        created: function(){
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.date2 = this.fecha_actual
            this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_shared(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_parking_reservations_received(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_parking_reservations_sent(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_parking_invitations_received(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            // this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            this.get_enterprise_invitations()
            this.get_normal_invitations()
            this.get_assigned_invitations()
            this.get_assigned_shipments()
            this.getRecurrentEnterpriseInvitations()
            // Set active tab based on role: for non-providers, show "Enviados" first
            if (this.getProfile.roll !== 15 && this.getProfile.roll !== 11) {
                this.activeTab = 1 // Enviados tab
            } else {
                this.activeTab = 0 // Recibidos tab
            }
        },

        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if ( val !== null && val !== undefined)
                    if (val.length > 2){

                        this.isLoading = true

                        // Lazily load input items
                        const config = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/empleados/filter?search=' + val,
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        };
                        axios(config)
                            .then(response => {
                                console.log(response.data)
                                const data = Array.isArray(response.data) ? response.data : []
                                if(this.entries.length > 0){
                                    for(var i =0 ; i < data.length; i++){
                                        this.entries.push(data[i])
                                    }
                                }
                                else
                                    this.entries = data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                            .finally(() => (this.isLoading = false))
                    }
            },
            reassignSearch (val) {
                if (val === null || val === undefined || val.length <= 2) {
                    if (val === null || val === '') {
                        this.reassignItems = this.allCompanyEmployees;
                    }
                    return;
                }
                this.reassignIsLoading = true;
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/empleados/filter?search=' + val,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.reassignItems = Array.isArray(response.data) ? response.data : [];
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => (this.reassignIsLoading = false));
            }
        },
        beforeUpdate() {
            this.headersSent = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'canceled'
                },
                {
                    text: this.$t('asistira'),
                    align: 'left',
                    sortable: true,
                    value: 'confirmed'
                },
                {
                    text: this.$t('multiple_accesses'),
                    align: 'left',
                    sortable: true,
                    value: 'multiple_accesses'
                },
                {
                    text: this.$t('fecha_envio'),
                    align: 'left',
                    sortable: true,
                    value: 'fechaEnvio'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_invitacion'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'hostFirstName'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guestFirstName'
                },
                {
                    text: 'Andén/Área',
                    align: 'left',
                    sortable: true,
                    value: 'normalizedArea'
                },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'vehiculo'
                },
                ...(this.getProfile.enable_shipments ? [{
                    text: 'Externa',
                    align: 'center',
                    sortable: true,
                    value: 'is_external_invitation'
                }] : [])
            ],
            this.headersRecurrentEnterpriseInvitations = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'left',
                    sortable: true,
                    value: 'dateInv'
                },
                {
                    text: this.$t('fecha_expiracion'),
                    align: 'left',
                    sortable: true,
                    value: 'expiration'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'hostName'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'companyName'
                },
                {
                    text: this.$t('Area'),
                    align: 'left',
                    sortable: true,
                    value: 'areaName'
                },
                {
                    text: this.$t('Asunto'),
                    align: 'left',
                    sortable: true,
                    value: 'subject'
                }
            ],
            this.headersAccess = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'invitado'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('temperature'),
                    align: 'left',
                    sortable: true,
                    value: 'temperature'
                },
                {
                    text: this.$t('estado'),
                    align: 'left',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'id_invitacion'
                }
            ],
            this.headersAccess2 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('type_of_access'),
                    align: 'left',
                    sortable: true,
                    value: 'access_qr_code'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkout'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ],
            this.headersRecieved = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'left',
                    sortable: true,
                    value: 'tipo'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'canceled'
                },
                {
                    text: this.$t('asistira'),
                    align: 'center',
                    sortable: true,
                    value: 'confirmed'
                },
                {
                    text: this.$t('multiple_accesses'),
                    align: 'center',
                    sortable: true,
                    value: 'multiple_accesses'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_invitacion'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'hostFirstName'
                },
                {
                    text: 'Andén/Área',
                    align: 'left',
                    sortable: true,
                    value: 'normalizedArea'
                },
                {
                    text: this.$t('Area'),
                    align: 'left',
                    sortable: true,
                    value: 'areaName'
                },
                {
                    text: this.$t('Asunto'),
                    align: 'left',
                    sortable: true,
                    value: 'guestCellPhone'
                },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'hostFirstName'
                }
            ],
            this.headersRecievedExcel = [
                {
                    label: this.$t('Tipo'),
                    field: 'tipo'
                },
                {
                    label: this.$t('asistira'),
                    field: 'confirmed'
                },
                {
                    label: this.$t('fecha_hora'),
                    field: 'fecha_hora'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'anfitrion'
                },
                {
                    label: 'Andén/Área',
                    field: 'area'
                },
                {
                    label: this.$t('Asunto'),
                    field: 'asunto'
                },
                {
                    label: this.$t('mensaje_vehiculo'),
                    field: 'automovil'
                }
            ],
            this.headersSentExcel = [
                {
                    label: this.$t('Tipo'),
                    field: 'tipo'
                },
                {
                    label: this.$t('asistira'),
                    field: 'confirmed'
                },
                {
                    label: this.$t('fecha_envio'),
                    field: 'fecha_envio'
                },
                {
                    label: this.$t('fecha_hora'),
                    field: 'fecha_hora'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'anfitrion'
                },
                {
                    label: this.$t('Visitante'),
                    field: 'visitante'
                },
                {
                    label: 'Andén/Área',
                    field: 'area'
                },
                {
                    label: this.$t('mensaje_vehiculo'),
                    field: 'automovil'
                },
                ...(this.getProfile.enable_shipments ? [{
                    label: 'Externa',
                    field: 'is_external_invitation'
                }] : [])
            ],
            this.headersAccessExcel = [
                {
                    label: this.$t('type_of_access'),
                    field: 'access_qr_code',
                    dataFormat: this.typeAccessFormat
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest_full_name'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'company_name',
                },
                {
                    label: this.$t('estado'),
                    field: 'status',
                    dataFormat: this.estadoFormat
                },
                {
                    label: this.$t('hora_llegada'),
                    field: 'datetime_arrival'
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'datetime_checkin'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'datetime_checkout'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'host_full_name'
                }
            ],
            this.headersAccessNoCodeExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'empresa',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'hostFirstName'
                }
            ],
            this.headersRecievedExcelPark = [
                {
                    label: this.$t('Tipo'),
                    field: 'invitation',
                    dataFormat: this.typeInvitationParkFormat
                },
                {
                    label: this.$t('asistira'),
                    field: 'confirmed',
                    dataFormat: this.boolFormat
                },
                {
                    label: this.$t('fecha_hora'),
                    field: 'invitation',
                    dataFormat: this.dateParkFormat
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'host',
                    dataFormat: this.hostNameParkFormat
                },
                {
                    label: this.$t('Parque'),
                    field: 'invitation',
                    dataFormat: this.parkNameFormat
                },
                {
                    label: this.$t('Asunto'),
                    field: 'invitation',
                    dataFormat: this.subjectFormat
                },
                {
                    label: this.$t('mensaje_vehiculo'),
                    field: 'invitation',
                    dataFormat: this.boolFormat2
                }
            ],
            this.headersRecievedPark = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Tipo'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.typeInv'
                },
                {
                    text: this.$t('asistira'),
                    align: 'center',
                    sortable: true,
                    value: 'confirmed'
                },
                {
                    text: this.$t('fecha_hora'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.dateInv'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'center',
                    sortable: true,
                    value: 'host.first_name'
                },
                // {
                //     text: this.$t('Empresa'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'empresa'
                // },
                {
                    text: this.$t('Parque'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.park_name'
                },
                {
                    text: this.$t('Asunto'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.subject'
                },
                {
                    text: this.$t('mensaje_vehiculo'),
                    align: 'center',
                    sortable: true,
                    value: 'invitation.vehicle'
                }
            ],
            this.headersAccessNoCode = [
                    {
                        text: this.$t('detalle'),
                        align: 'center',
                        sortable: false,
                        value: 'details'
                    },
                    {
                        text: this.$t('Visitante'),
                        align: 'left',
                        sortable: true,
                        value: 'nombre'
                    },
                    {
                        text: this.$t('Empresa'),
                        align: 'left',
                        sortable: true,
                        value: 'empresa'
                    },
                    {
                        text: this.$t('estado'),
                        align: 'center',
                        sortable: true,
                        value: 'estado'
                    },
                    {
                        text: this.$t('hora_acceso'),
                        align: 'left',
                        sortable: true,
                        value: 'f_acceso'
                    },
                    {
                        text: this.$t('hora_salida'),
                        align: 'left',
                        sortable: true,
                        value: 'f_salida'
                    },
                    {
                        text: this.$t('Anfitrion'),
                        align: 'left',
                        sortable: true,
                        value: 'nombre'
                    }
                ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            ineUpdateChannels () {
                const invitation = this.info_invitation[0]
                if (!invitation) {
                    return []
                }

                const channels = []
                if (invitation.guestCellPhone && String(invitation.guestCellPhone).trim()) {
                    channels.push({ label: 'SMS', value: 'SMS' })
                }
                const guestEmail = true
                if (guestEmail && String(guestEmail).trim()) {
                    channels.push({ label: 'Correo electrónico', value: 'EMAIL' })
                }
                return channels
            },
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            },
            accesosWithoutCodeForExcel () {
                return (this.accesos_without_code || []).map(item => {
                    return {
                        ...item,
                        f_acceso: item.f_acceso ? this.formatDateDDMMYYYY(item.f_acceso) : '',
                        f_salida: item.f_salida ? this.formatDateDDMMYYYY(item.f_salida) : 'Salida no registrada',
                        hostFirstName: item.host
                    }
                })
            },
            accessForExcel () {
                return this.access.map(item => {
                    let mappedItem = { ...item }
                    if (mappedItem.status === 2 && mappedItem.exit_pass === false) {
                        mappedItem.status = 3
                    }
                    mappedItem.datetime_arrival = this.formatDateDDMMYYYY(mappedItem.datetime_arrival)
                    mappedItem.datetime_checkin = mappedItem.datetime_checkin === null ? 'Pendiente' : this.formatDateDDMMYYYY(mappedItem.datetime_checkin)
                    mappedItem.datetime_checkout = mappedItem.datetime_checkout === null ? 'Pendiente' : this.formatDateDDMMYYYY(mappedItem.datetime_checkout)

                    return mappedItem
                })
            },
            mappedInvitacionesRecibidasExport() {
                return (this.mappedInvitacionesRecibidasForRecibidos || []).map(item => ({
                    tipo: item.chipText || '-',
                    confirmed: item.confirmed ? this.$t('Si') : 'No',
                    fecha_hora: item.normalizedDate ? `${this.formatDateDDMMYYYY(item.normalizedDate)} ${item.normalizedTime || ''}`.trim() : '-',
                    anfitrion: item.normalizedHost || '-',
                    area: item.normalizedArea || '-',
                    asunto: item.normalizedSubject || '-',
                    automovil: item.automovil ? this.$t('Si') : (item.isShipment ? '-' : 'No'),
                }))
            },
            mappedInvitacionesRecibidasForRecibidos() {
                return (this.mappedInvitacionesRecibidas || []).filter(item => {
                    if (!item.isShipment) return true
                    const status = item.shipping_window_detail ? item.shipping_window_detail.status : null
                    return status !== 'PROGRAMADA'
                })
            },
            pendingAllInvitations() {
                let pendingItems = [];
                
                // Filter existing mapped received invitations
                const mappedPending = (this.mappedInvitacionesRecibidas || []).filter(item => {
                    if (item.isShipment) {
                        return item.shipping_window_detail
                            ? item.shipping_window_detail.status === 'PROGRAMADA'
                            : false;
                    }
                    return item.canceled !== true && item.confirmed !== true;
                });
                
                // Map enterprise invitations to expected format
                const enterprisePending = (this.enterprise_invitations || []).map((item, idx) => ({
                    uniqueId: `enterprise-${item.id}-${idx}`,
                    id: item.id,
                    subject: item.subject,
                    chipText: 'Invitación Empresarial',
                    chipColor: '#FF9800',
                    isShipment: false,
                    isParkingData: false,
                    normalizedDate: item.dateInv,
                    normalizedTime: item.timeInv,
                    normalizedHost: item.companyFrom || (item.id_empresa && item.id_empresa.name),
                    normalizedArea: item.subject,
                    normalizedSubject: item.subject,
                    Token: item.Token,
                    email: item.referredMail,
                    phone: item.referredPhone,
                    assigned: item.assigned
                }));
                
                // Map normal invitations to expected format
                const normalPending = (this.normal_invitations || []).map((item, idx) => ({
                    uniqueId: `normal-${item.id}-${idx}`,
                    id: item.id,
                    invitation_id: item.invitation_id,
                    asunto: item.asunto,
                    chipText: 'Invitación Normal',
                    chipColor: '#2196F3',
                    isShipment: false,
                    isParkingData: false,
                    normalizedDate: item.dateInv,
                    normalizedTime: item.timeInv,
                    normalizedHost: item.empresa,
                    normalizedArea: item.asunto,
                    normalizedSubject: item.asunto,
                    qr_code: item.qr_code,
                    confirmed: item.confirmed,
                    authorized: item.authorized
                }));
                
                // Combine all pending invitations
                pendingItems = [...mappedPending, ...enterprisePending, ...normalPending];
                
                return pendingItems;
            },
            headersPendingAll() {
                return [
                    { text: 'Acción', value: null, sortable: false },
                    { text: 'Tipo', value: 'chipText' },
                    { text: 'Fecha y hora', value: 'normalizedDate' },
                    { text: 'Anfitrión / Remitente', value: 'normalizedHost' },
                    { text: 'Área / Asunto', value: 'normalizedArea' },
                    { text: 'Estado', value: null, sortable: false },
                ];
            },
            mappedInvitacionesExport() {
                return (this.mappedInvitaciones || []).map(item => ({
                    tipo: item.chipText || '-',
                    confirmed: item.confirmed ? this.$t('Si') : 'No',
                    fecha_envio: item.fechaEnvio || '-',
                    fecha_hora: item.normalizedDate ? `${this.formatDateDDMMYYYY(item.normalizedDate)} ${item.normalizedTime || ''}`.trim() : '-',
                    anfitrion: item.normalizedHost || '-',
                    visitante: item.normalizedGuest || (item.guestFirstName ? `${item.guestFirstName} ${item.guestLastName || ''}`.trim() : '-'),
                    area: item.normalizedArea || '-',
                    automovil: item.automovil ? this.$t('Si') : (item.isShipment ? '-' : 'No'),
                    is_external_invitation: item.is_external_invitation !== undefined ? (item.is_external_invitation ? this.$t('Si') : 'No') : '-',
                }))
            },
            mappedInvitacionesSharedExport() {
                return (this.mappedInvitacionesShared || []).map(item => ({
                    tipo: item.chipText || '-',
                    confirmed: item.confirmed ? this.$t('Si') : 'No',
                    fecha_envio: item.fechaEnvio || '-',
                    fecha_hora: item.normalizedDate ? `${this.formatDateDDMMYYYY(item.normalizedDate)} ${item.normalizedTime || ''}`.trim() : '-',
                    anfitrion: item.normalizedHost || '-',
                    visitante: item.normalizedGuest || (item.guestFirstName ? `${item.guestFirstName} ${item.guestLastName || ''}`.trim() : '-'),
                    area: item.normalizedArea || '-',
                    automovil: item.automovil ? this.$t('Si') : (item.isShipment ? '-' : 'No'),
                    is_external_invitation: item.is_external_invitation !== undefined ? (item.is_external_invitation ? this.$t('Si') : 'No') : '-',
                }))
            },
            fields () {
                if (!this.email) return []

                return Object.keys(this.email).map(key => {
                    return {
                        key,
                        value: this.email[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            },
            mappedInvitacionesRecibidas() {
                let mapped = [];
                // Process invitaciones_recibidas (Empresas & Shipments)
                if (this.invitaciones_recibidas) {
                    this.invitaciones_recibidas.forEach(item => {
                        let isShipment = item.shipping_window_detail !== undefined || item.is_external_invitation !== undefined;
                        if (isShipment) {
                            mapped.push({
                                ...item,
                                uniqueId: 'uid_' + mapped.length,
                                chipColor: 'orange',
                                chipText: 'Embarques',
                                isShipment: true,
                                normalizedDate: item.shipping_window_detail ? item.shipping_window_detail.window_date : (item.dateInv || ''),
                                normalizedTime: item.shipping_window_detail ? (item.shipping_window_detail.window_time || '').split('.')[0] : (item.timeInv || '').split('.')[0],
                                normalizedHost: item.shipping_window_detail && item.shipping_window_detail.loading_area_detail && item.shipping_window_detail.loading_area_detail.empresa ? item.shipping_window_detail.loading_area_detail.empresa.name : (item.empresa_name || ''),
                                normalizedArea: item.shipping_window_detail && item.shipping_window_detail.loading_area_detail ? item.shipping_window_detail.loading_area_detail.name : (item.areaName || ''),
                                normalizedSubject: item.asunto || item.subject || '',
                                confirmed: item.assigned_drivers && item.assigned_drivers.length > 0 ? item.assigned_drivers.some(d => d.confirmed) : false,
                                canceled: item.shipping_window_detail ? item.shipping_window_detail.status === "CANCELADA" : false,
                            });
                        } else {
                            mapped.push({
                                ...item,
                                uniqueId: 'uid_' + mapped.length,
                                chipColor: item.typeInv === 2 ? 'deep-purple' : 'blue',
                                chipText: item.typeInv === 2 ? 'Empresa Recurrente' : 'Empresa Normal',
                                isShipment: false,
                                normalizedDate: item.dateInv,
                                normalizedTime: (item.timeInv || '').split('.')[0],
                                normalizedHost: `${item.hostFirstName || ''} ${item.hostLastName || ''}`.trim(),
                                normalizedArea: item.areaName,
                                normalizedSubject: item.asunto,
                            });
                        }
                    });
                }
                // Process invitaciones_recibidas_park - DEPRECATED, replaced by parking_reservations_received
                // Removed legacy parking invitations processing
                
                // Process parking_reservations_received (Reservas de Estacionamiento - new API)
                if (this.parking_reservations_received && Array.isArray(this.parking_reservations_received)) {
                    this.parking_reservations_received.forEach(item => {
                        const dateRange = item.start_date === item.end_date 
                            ? this.formatDateDDMMYYYY(item.start_date)
                            : `${this.formatDateDDMMYYYY(item.start_date)} - ${this.formatDateDDMMYYYY(item.end_date)}`;
                        
                        const timeRange = item.start_time && item.end_time
                            ? `${item.start_time} - ${item.end_time}`
                            : 'Todo el día';
                        
                        mapped.push({
                            ...item,
                            uniqueId: 'uid_' + mapped.length,
                            chipColor: item.status === 'active' ? 'green' : 'orange',
                            chipText: 'Reserva Estacionamiento',
                            isShipment: false,
                            normalizedDate: item.start_date,
                            normalizedTime: timeRange,
                            normalizedHost: item.owner_company_name || '-',
                            normalizedArea: item.reserved_spaces && item.reserved_spaces.length > 0 
                                ? item.reserved_spaces.map(s => s.space_number).join(', ')
                                : '-',
                            normalizedSubject: item.notes || '-',
                            canceled: item.status === 'canceled',
                            confirmed: item.status === 'active',
                            automovil: false,
                            isParkingData: true,
                            isParkingReservation: true,
                            dateRange: dateRange,
                            spacesCount: item.reserved_spaces ? item.reserved_spaces.length : 0
                        });
                    });
                }
                
                // Process parking_invitations_received (Estacionamiento - old API)
                if (this.parking_invitations_received) {
                    const processParkingArray = (arr, isPending) => {
                        if (Array.isArray(arr)) {
                            arr.forEach(item => {
                                mapped.push({
                                    ...item,
                                    uniqueId: 'uid_' + mapped.length,
                                    chipColor: isPending ? 'grey' : 'green',
                                    chipText: isPending ? 'Estacionamiento (Pendiente)' : 'Estacionamiento',
                                    isShipment: false,
                                    fechaEnvio: item.created_at || '-',
                                    normalizedDate: item.invitation_date,
                                    normalizedTime: this.getParkingTimeRange(item),
                                    normalizedHost: `${item.host_first_name || ''} ${item.host_last_name || ''}`.trim(),
                                    normalizedArea: '-',
                                    normalizedSubject: isPending ? (item.referred_email || item.referred_phone) : item.subject,
                                    typeInv: item.invitation_type,
                                    canceled: item.canceled,
                                    confirmed: isPending ? false : item.confirmed,
                                    automovil: item.vehicle_type_name ? true : false,
                                    isParkingData: true,
                                    isParkingPendingReferred: isPending,
                                });
                            });
                        }
                    };

                    if (Array.isArray(this.parking_invitations_received)) {
                        processParkingArray(this.parking_invitations_received, false);
                    } else {
                        processParkingArray(this.parking_invitations_received.invitations, false);
                        processParkingArray(this.parking_invitations_received.pending_referred, true);
                    }
                }
                
                // Add sorting property and Sort array by complete date
                return mapped.map(item => ({
                    ...item,
                    fecha_hora_invitacion: `${item.normalizedDate} ${item.normalizedTime}`
                })).sort((a,b) => {
                    return this.dateSortValue(b.normalizedDate, b.normalizedTime) - this.dateSortValue(a.normalizedDate, a.normalizedTime)
                });
            },
            mappedInvitaciones() {
                let mapped = [];
                if (this.invitaciones) {
                    this.invitaciones.forEach(item => {
                        let isShipment = item.shipping_window_detail !== undefined || item.is_external_invitation !== undefined;
                        if (isShipment) {
                            mapped.push({
                                ...item,
                                uniqueId: 'uid_' + mapped.length,
                                chipColor: 'orange',
                                chipText: 'Embarques',
                                isShipment: true,
                                fechaEnvio: item.created_at ? `${item.created_at.substring(8,10)}-${item.created_at.substring(5,7)}-${item.created_at.substring(0,4)}` : (item.fechaEnvio || '-'),
                                normalizedDate: item.shipping_window_detail ? item.shipping_window_detail.window_date : (item.dateInv || ''),
                                normalizedTime: item.shipping_window_detail ? (item.shipping_window_detail.window_time || '').split('.')[0].substring(0,5) : (item.timeInv || '').split('.')[0].substring(0,5),
                                normalizedHost: item.invited_by_company_name || 
                                (item.shipping_window_detail 
                                    ? (item.shipping_window_detail.client_detail && item.shipping_window_detail.client_detail.name 
                                        ? item.shipping_window_detail.client_detail.name 
                                        : item.shipping_window_detail.client_name || '')
                                    : (item.empresa_name || '')),
                                normalizedGuest: item.invited_company_name || item.unregistered_company_name || '',
                                normalizedArea: item.shipping_window_detail 
                                    ? (item.shipping_window_detail.loading_area_detail && item.shipping_window_detail.loading_area_detail.name 
                                        ? item.shipping_window_detail.loading_area_detail.name 
                                        : item.shipping_window_detail.loading_area || '')
                                    : (item.areaName || ''),
                                normalizedSubject: item.asunto || item.subject || '',
                                confirmed: item.assigned_drivers && item.assigned_drivers.length > 0 ? item.assigned_drivers.some(d => d.confirmed) : false,
                                canceled: item.shipping_window_detail ? item.shipping_window_detail.status === "CANCELADA" : false,
                            });
                        } else {
                            mapped.push({
                                ...item,
                                uniqueId: 'uid_' + mapped.length,
                                chipColor: item.typeInv === undefined && item.park_name ? 'green' : (item.typeInv === 2 ? 'deep-purple' : 'blue'),
                                chipText: item.typeInv === undefined && item.park_name ? 'Estacionamiento' : (item.typeInv === 2 ? 'Empresa Recurrente' : 'Empresa Normal'),
                                isShipment: false,
                                fechaEnvio: item.created_at ? `${item.created_at.substring(8,10)}-${item.created_at.substring(5,7)}-${item.created_at.substring(0,4)}` : (item.fechaEnvio || '-'),
                                normalizedDate: item.dateInv,
                                normalizedTime: (item.timeInv || '').split('.')[0].substring(0,5),
                                normalizedHost: `${item.hostFirstName || ''} ${item.hostLastName || ''}`.trim(),
                                normalizedGuest: `${item.guestFirstName || ''} ${item.guestLastName || ''}`.trim(),
                                normalizedArea: item.park_name || item.areaName,
                                normalizedSubject: item.asunto,
                            });
                        }
                    });
                }
                
                // Process parking_reservations_sent (Reservas de Estacionamiento - new API)
                if (this.parking_reservations_sent && Array.isArray(this.parking_reservations_sent)) {
                    this.parking_reservations_sent.forEach(item => {
                        const dateRange = item.start_date === item.end_date 
                            ? this.formatDateDDMMYYYY(item.start_date)
                            : `${this.formatDateDDMMYYYY(item.start_date)} - ${this.formatDateDDMMYYYY(item.end_date)}`;
                        
                        const timeRange = item.start_time && item.end_time
                            ? `${item.start_time} - ${item.end_time}`
                            : 'Todo el día';
                        
                        mapped.push({
                            ...item,
                            uniqueId: 'uid_' + mapped.length,
                            chipColor: item.status === 'active' ? 'green' : 'orange',
                            chipText: 'Reserva Estacionamiento',
                            isShipment: false,
                            normalizedDate: item.start_date,
                            normalizedTime: timeRange,
                            normalizedHost: item.beneficiary_company_name || '-',
                            normalizedGuest: item.beneficiary_company_name || '-',
                            normalizedArea: item.reserved_spaces && item.reserved_spaces.length > 0 
                                ? item.reserved_spaces.map(s => s.space_number).join(', ')
                                : '-',
                            normalizedSubject: item.notes || '-',
                            canceled: item.status === 'canceled',
                            confirmed: item.status === 'active',
                            automovil: false,
                            isParkingData: true,
                            isParkingReservation: true,
                            dateRange: dateRange,
                            spacesCount: item.reserved_spaces ? item.reserved_spaces.length : 0
                        });
                    });
                }
                
                // Process parking_invitations_sent (old API - DEPRECATED)
                if (this.parking_invitations_sent) {
                    const processParkingSentArray = (arr, isPending) => {
                        if (Array.isArray(arr)) {
                            arr.forEach(item => {
                                mapped.push({
                                    ...item,
                                    uniqueId: 'uid_' + mapped.length,
                                    chipColor: isPending ? 'grey' : 'green',
                                    chipText: isPending ? 'Estacionamiento (Pendiente)' : 'Estacionamiento',
                                    isShipment: false,
                                    fechaEnvio: item.created_at || '-',
                                    normalizedDate: item.invitation_date,
                                    normalizedTime: this.getParkingTimeRange(item),
                                    normalizedHost: item.company_name || '',
                                    normalizedGuest: isPending ? (item.referred_email || item.referred_phone || '') : `${item.guest_first_name || ''} ${item.guest_last_name || ''}`.trim(),
                                    normalizedArea: '-',
                                    normalizedSubject: item.subject,
                                    isParkingData: true,
                                    isParkingPendingReferred: isPending,
                                });
                            });
                        }
                    };

                    if (Array.isArray(this.parking_invitations_sent)) {
                        processParkingSentArray(this.parking_invitations_sent, false);
                    } else {
                        processParkingSentArray(this.parking_invitations_sent.invitations, false);
                        processParkingSentArray(this.parking_invitations_sent.pending_referred, true);
                    }
                }
                // Add sorting property and Sort array by complete date
                return mapped.map(item => ({
                    ...item,
                    fecha_hora_invitacion: `${item.normalizedDate} ${item.normalizedTime}`
                })).sort((a,b) => {
                    return this.dateSortValue(b.normalizedDate, b.normalizedTime) - this.dateSortValue(a.normalizedDate, a.normalizedTime)
                });
            },
            mappedInvitacionesShared() {
                let mapped = [];
                if (this.invitaciones_shared) {
                    this.invitaciones_shared.forEach(item => {
                        let isShipment = item.shipping_window_detail !== undefined || item.is_external_invitation !== undefined;
                        if (isShipment) {
                                mapped.push({
                                    ...item,
                                    uniqueId: 'uid_' + mapped.length,
                                    chipColor: 'orange',
                                    chipText: 'Embarques',
                                    isShipment: true,
                                    fechaEnvio: item.created_at ? `${item.created_at.substring(8,10)}/${item.created_at.substring(5,7)}/${item.created_at.substring(0,4)} ${item.created_at.length > 10 ? item.created_at.substring(11,16) : ''}`.trim() : (item.fechaEnvio || '-'),
                                    normalizedDate: item.shipping_window_detail ? item.shipping_window_detail.window_date : (item.dateInv || ''),
                                    normalizedTime: item.shipping_window_detail ? (item.shipping_window_detail.window_time || '').split('.')[0] : (item.timeInv || '').split('.')[0],
                                    normalizedHost: item.invited_by_company_name || 
                                    (item.shipping_window_detail 
                                        ? (item.shipping_window_detail.client_detail && item.shipping_window_detail.client_detail.name 
                                            ? item.shipping_window_detail.client_detail.name 
                                            : item.shipping_window_detail.client_name || '')
                                        : (item.empresa_name || '')),
                                                        normalizedGuest: item.invited_company_name || item.unregistered_company_name || '',
                                                        normalizedArea: item.shipping_window_detail 
                                        ? (item.shipping_window_detail.loading_area_detail && item.shipping_window_detail.loading_area_detail.name 
                                            ? item.shipping_window_detail.loading_area_detail.name 
                                            : item.shipping_window_detail.loading_area || '')
                                        : (item.areaName || ''),
                                    normalizedSubject: item.asunto || item.subject || '',
                                    confirmed: item.assigned_drivers && item.assigned_drivers.length > 0 ? item.assigned_drivers.some(d => d.confirmed) : false,
                                });
                            }else {
                            mapped.push({
                                ...item,
                                uniqueId: 'uid_' + mapped.length,
                                chipColor: item.typeInv === 2 ? 'deep-purple' : 'blue',
                                chipText: item.typeInv === 2 ? 'Empresa Recurrente' : 'Empresa Normal',
                                isShipment: false,
                                fechaEnvio: item.created_at ? `${item.created_at.substring(8,10)}/${item.created_at.substring(5,7)}/${item.created_at.substring(0,4)} ${item.created_at.length > 10 ? item.created_at.substring(11,16) : ''}`.trim() : (item.fechaEnvio || '-'),
                                normalizedDate: item.dateInv,
                                normalizedTime: (item.timeInv || '').split('.')[0],
                                normalizedHost: `${item.hostFirstName || ''} ${item.hostLastName || ''}`.trim(),
                                normalizedGuest: `${item.guestFirstName || ''} ${item.guestLastName || ''}`.trim(),
                                normalizedArea: item.areaName,
                                normalizedSubject: item.asunto,
                            });
                        }
                    });
                }
                // Add sorting property and Sort array by complete date
                return mapped.map(item => ({
                    ...item,
                    fecha_hora_invitacion: `${item.normalizedDate} ${item.normalizedTime}`
                })).sort((a,b) => {
                    let dateA = new Date(`${a.normalizedDate} ${a.normalizedTime}`);
                    let dateB = new Date(`${b.normalizedDate} ${b.normalizedTime}`);
                    return dateB - dateA;
                });
            },
            mappedAssignedInvitations() {
                // Map enterprise invitations (normal and recurring)
                const mappedInvitations = (this.assigned_invitations || []).flatMap((item, idx) => {
                    // Check if it's a recurring invitation with assigned_employees array
                    if (item.type === 'recurring' && item.assigned_employees && Array.isArray(item.assigned_employees)) {
                        // For recurring invitations, create a mapped item for each assigned employee
                        return item.assigned_employees.map((employee, empIdx) => ({
                            uniqueId: `assigned-inv-recurring-${item.id}-${employee.employee_id}-${empIdx}`,
                            id: item.id,
                            chipText: 'Invitación Recurrente',
                            chipColor: '#FF6F00',
                            type: 'recurring',
                            employee_name: employee.employee_name || '',
                            employee_email: employee.employee_email || '',
                            employee_phone: employee.employee_phone || '',
                            subject: item.subject || '',
                            company_name: item.companyName || '',
                            area_name: item.areaName || '',
                            date_invitation: item.dateInv || '',
                            time_invitation: item.timeInv || '',
                            expiration_date: item.expiration || '',
                            notes: '',
                            vehicle_required: false,
                            multiple_accesses: false,
                            host_name: item.hostName || '',
                            host_email: '',
                            qr_code: employee.qr_code || item.qr_code || '',
                            employee_avatar: employee.employee_avatar || '',
                            confirmed: employee.confirmed || false,
                            authorized: employee.authorized || false,
                            canceled: employee.canceled || false,
                            created_date: ''
                        }));
                    }
                    // For normal invitations
                    return [{
                        uniqueId: `assigned-inv-${item.id}-${idx}`,
                        id: item.id,
                        chipText: 'Invitación Empresarial',
                        chipColor: '#9C27B0',
                        type: 'invitation',
                        employee_name: item.employee_name || '',
                        employee_email: item.employee_email || '',
                        employee_phone: item.employee_phone || '',
                        subject: item.subject || '',
                        company_name: item.company_name || '',
                        area_name: item.area_name || '',
                        date_invitation: item.date_invitation || '',
                        time_invitation: item.time_invitation || '',
                        expiration_date: item.expiration_date || '',
                        notes: item.notes || '',
                        vehicle_required: item.vehicle_required || false,
                        multiple_accesses: item.multiple_accesses || false,
                        host_name: item.host_name || '',
                        host_email: item.host_email || '',
                        qr_code: item.qr_code || '',
                        employee_avatar: item.employee_avatar || '',
                        confirmed: item.confirmed || false,
                        authorized: item.authorized || false,
                        canceled: item.canceled || false,
                        created_date: item.created_date || ''
                    }];
                });

                // Map assigned shipments
                const mappedShipments = (this.assigned_shipments || []).map((item, idx) => ({
                    uniqueId: `assigned-ship-${item.id}-${idx}`,
                    id: item.id,
                    chipText: 'Embarque',
                    chipColor: '#FF9800',
                    type: 'shipment',
                    employee_name: item.employee_name || '',
                    employee_email: item.employee_email || '',
                    employee_phone: item.employee_phone || '',
                    subject: item.client_name || '',
                    company_name: item.company_name || '',
                    area_name: item.loading_area || '',
                    date_invitation: item.window_date || '',
                    time_invitation: item.window_time || '',
                    expiration_date: item.window_date || '',
                    notes: item.observations || '',
                    vehicle_required: false,
                    multiple_accesses: false,
                    host_name: '',
                    host_email: '',
                    qr_code: item.qr_code || '',
                    employee_avatar: item.employee_avatar || '',
                    confirmed: item.confirmed || false,
                    authorized: item.authorized || false,
                    canceled: item.canceled || false,
                    created_date: ''
                }));

                return [...mappedInvitations, ...mappedShipments];
            },
            headersAssignedInvitations() {
                return [
                    { text: 'Tipo', value: 'chipText', sortable: true },
                    { text: 'Acción', value: null, sortable: false, align: 'center' },
                    { text: 'Empleado', value: 'employee_name', sortable: true },
                    { text: 'Email', value: 'employee_email', sortable: true },
                    { text: 'Teléfono', value: 'employee_phone', sortable: true },
                    { text: 'Invitación', value: 'subject', sortable: true },
                    { text: 'Empresa', value: 'company_name', sortable: true },
                    { text: 'Área', value: 'area_name', sortable: true },
                    { text: 'Fecha y Hora', value: 'date_invitation', sortable: true },
                    { text: 'Vencimiento', value: 'expiration_date', sortable: true },
                    { text: 'Vehículo', value: 'vehicle_required', sortable: true, align: 'center' },
                    { text: 'Accesos Múltiples', value: 'multiple_accesses', sortable: true, align: 'center' },
                    { text: 'Confirmada', value: 'confirmed', sortable: true, align: 'center' },
                    { text: 'Autorizada', value: 'authorized', sortable: true, align: 'center' },
                ];
            },
            hasMissingDocuments() {
                // Retorna true si hay documentos faltantes (sin archivo)
                return this.missingDocumentations.some(doc => !doc.file)
            },
            filteredAvailableVehicles() {
                // Filtra vehículos disponibles excluyendo el vehículo actual asignado
                if (!this.selectedDriver || !this.selectedDriver.vehicle) {
                    return this.availableVehicles
                }
                return this.availableVehicles.filter(v => v.id !== this.selectedDriver.vehicle.id)
            }
        },
        methods:{
            isEmployee(driver) {
                if (!this.allCompanyEmployees || this.allCompanyEmployees.length === 0) return false;
                return this.allCompanyEmployees.some(emp => emp.id_usuario && emp.id_usuario.email === driver.email);
            },
            openDriversModal(invitation, canReassign) {
                this.selectedInvitation = invitation;
                this.canReassignDrivers = canReassign === true;
                this.dialogDrivers = true;
                if (!this.allCompanyEmployees || this.allCompanyEmployees.length === 0) {
                    this.get_all_employees_for_reassign();
                }
            },
            goToShippingForm(token) {
                this.$router.push('/form_shipping_window_invitation_data/' + token);
            },
            goToEnterpriseForm(token) {
                this.$router.push('/form_invitation_data/' + token);
            },
            copyQRCode(qrCode) {
                if (!qrCode) {
                    alert('No hay código QR disponible');
                    return;
                }
                navigator.clipboard.writeText(qrCode).then(() => {
                    alert('Código QR copiado al portapapeles');
                }).catch(err => {
                    console.error('Error copiando QR code:', err);
                    alert('Error al copiar el código QR');
                });
            },
            openAssignedInvitationDetail(invitation) {
                this.selected_assigned_invitation = invitation;
                this.dialog_assigned_detail = true;
            },
            downloadGafeteQR(invitation) {
                this.loadingPdfGafete = true;

                try {
                    const qrCanvas = document.createElement('canvas');
                    QRCode.toCanvas(qrCanvas, invitation.qr_code, { width: 110 * 3 }, (error) => {
                        if (error) {
                            console.error('Error generando QR:', error);
                            alert('Error al generar el código QR');
                            this.loadingPdfGafete = false;
                            return;
                        }

                        const qrImageData = qrCanvas.toDataURL('image/png');

                        const SCALE = 3;
                        const W = 595 * SCALE;
                        const H = 842 * SCALE;
                        const gafeteCanvas = document.createElement('canvas');
                        gafeteCanvas.width = W;
                        gafeteCanvas.height = H;
                        const ctx = gafeteCanvas.getContext('2d');
                        const left = 40 * SCALE;

                        // Fondo blanco
                        ctx.fillStyle = '#ffffff';
                        ctx.fillRect(0, 0, W, H);

                        // Borde
                        ctx.strokeStyle = '#1976d2';
                        ctx.lineWidth = 4 * SCALE;
                        ctx.strokeRect(5 * SCALE, 5 * SCALE, W - 10 * SCALE, H - 10 * SCALE);

                        // Encabezado azul
                        ctx.fillStyle = '#1976d2';
                        ctx.fillRect(5 * SCALE, 5 * SCALE, W - 10 * SCALE, 65 * SCALE);

                        // Título
                        ctx.fillStyle = '#ffffff';
                        ctx.font = 'bold ' + (28 * SCALE) + 'px Arial';
                        ctx.textAlign = 'center';
                        ctx.fillText('PASE DE ACCESO', W / 2, 48 * SCALE);

                        // QR en la parte superior
                        ctx.fillStyle = '#1976d2';
                        ctx.font = 'bold ' + (13 * SCALE) + 'px Arial';
                        ctx.textAlign = 'center';
                        ctx.fillText('ESCANEAR CÓDIGO QR', W / 2, 92 * SCALE);

                        const qrSize = 200 * SCALE;
                        const qrX = (W - qrSize) / 2;
                        const qrY = 100 * SCALE;

                        const qrImg = new Image();
                        qrImg.onload = () => {
                            ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

                            // Datos del empleado
                            let y = (100 + 200 + 20) * SCALE;

                            ctx.strokeStyle = '#e0e0e0';
                            ctx.lineWidth = SCALE;
                            ctx.beginPath();
                            ctx.moveTo(left, y);
                            ctx.lineTo(W - left, y);
                            ctx.stroke();

                            y += 22 * SCALE;
                            ctx.fillStyle = '#000000';
                            ctx.font = 'bold ' + (18 * SCALE) + 'px Arial';
                            ctx.textAlign = 'center';
                            ctx.fillText((invitation.employee_name || 'N/A').substring(0, 40), W / 2, y);

                            y += 24 * SCALE;
                            ctx.font = (13 * SCALE) + 'px Arial';
                            ctx.fillStyle = '#555555';
                            ctx.fillText((invitation.employee_email || 'N/A').substring(0, 50), W / 2, y);

                            y += 20 * SCALE;
                            ctx.fillText((invitation.employee_phone || 'N/A').substring(0, 40), W / 2, y);

                            // Línea separadora
                            y += 20 * SCALE;
                            ctx.strokeStyle = '#e0e0e0';
                            ctx.lineWidth = SCALE;
                            ctx.beginPath();
                            ctx.moveTo(left, y);
                            ctx.lineTo(W - left, y);
                            ctx.stroke();

                            // Datos de la invitación
                            y += 24 * SCALE;
                            ctx.fillStyle = '#1976d2';
                            ctx.font = 'bold ' + (13 * SCALE) + 'px Arial';
                            ctx.textAlign = 'left';
                            ctx.fillText('DATOS DE LA INVITACIÓN', left, y);

                            y += 22 * SCALE;
                            ctx.fillStyle = '#000000';
                            ctx.font = (12 * SCALE) + 'px Arial';
                            ctx.fillText('Asunto:    ' + (invitation.subject || 'N/A').substring(0, 45), left, y);

                            y += 20 * SCALE;
                            ctx.fillText('Empresa:  ' + (invitation.company_name || 'N/A').substring(0, 45), left, y);

                            y += 20 * SCALE;
                            ctx.fillText('Área:       ' + (invitation.area_name || 'N/A').substring(0, 45), left, y);

                            y += 20 * SCALE;
                            ctx.fillText('Fecha:     ' + (invitation.date_invitation || 'N/A'), left, y);

                            y += 20 * SCALE;
                            ctx.fillText('Vence:     ' + (invitation.expiration_date || 'N/A'), left, y);

                            // Pie de página
                            const footerY = H - 35 * SCALE;
                            ctx.fillStyle = '#1976d2';
                            ctx.fillRect(5 * SCALE, footerY - 10 * SCALE, W - 10 * SCALE, 50 * SCALE);
                            ctx.fillStyle = '#ffffff';
                            ctx.font = (11 * SCALE) + 'px Arial';
                            ctx.textAlign = 'center';
                            ctx.fillText('Presentar este pase al ingresar  |  Emisión: ' + new Date().toLocaleDateString('es-CO'), W / 2, footerY + 12 * SCALE);

                            // Powered by Intrare
                            ctx.fillStyle = '#999999';
                            ctx.font = (9 * SCALE) + 'px Arial';
                            ctx.textAlign = 'center';
                            ctx.fillText('Powered by Intrare', W / 2, H - 10 * SCALE);

                            // Generar PDF A4
                            const gafeteImageData = gafeteCanvas.toDataURL('image/png');
                            const doc = new jsPDF({
                                orientation: 'portrait',
                                unit: 'mm',
                                format: 'a4'
                            });
                            doc.addImage(gafeteImageData, 'PNG', 0, 0, 210, 297);
                            doc.save('gafete_' + invitation.employee_name.replace(/\s/g, '_') + '_' + new Date().getTime() + '.pdf');

                            this.loadingPdfGafete = false;
                        };
                        qrImg.src = qrImageData;
                    });
                } catch (error) {
                    console.error('Error generando PDF:', error);
                    alert('Error al generar el PDF. Por favor, intenta de nuevo.');
                    this.loadingPdfGafete = false;
                }
            },
            openReassignModal(driver) {
                this.reassignForm.old_qr_code = driver.qr_code;
                this.reassignForm.new_guest_email = '';
                this.dialogReassign = true;
                if(this.$refs.formReassign) {
                    this.$refs.formReassign.resetValidation();
                }
                this.reassignItems = [];
                this.get_all_employees_for_reassign();
            },
            closeReassignModal() {
                this.dialogReassign = false;
                this.reassignForm.old_qr_code = '';
                this.reassignForm.new_guest_email = '';
                this.selectedReassignEmployee = null;
                this.reassignItems = this.allCompanyEmployees;
                this.reassignSearch = '';
            },
            get_all_employees_for_reassign() {
                this.reassignIsLoading = true;
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/empleados/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        const data = Array.isArray(response.data) ? response.data : [];
                        this.allCompanyEmployees = data;
                        this.reassignItems = data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => (this.reassignIsLoading = false));
            },
            async submitReassign() {
                if (!this.$refs.formReassign.validate()) {
                    return;
                }
                this.loadingReassign = true;
                console.log(this.selectedReassignEmployee);
                try {
                    const url = `https://empresa-service.intrare.app/shipments/update-driver-assignation/`;
                    const payload = {
                        old_qr_code: this.reassignForm.old_qr_code,
                        new_guest_email: this.selectedReassignEmployee ? this.selectedReassignEmployee.id_usuario.email : this.reassignForm.new_guest_email
                    };

                    const config = {
                        method: 'post',
                        url: url,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: payload
                    };

                    await axios(config);
                    
                    this.$store.commit('snackbar_change_color', 'success');
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', 'Chofer reasignado exitosamente');
                    setTimeout(this.clear, 3000);

                    this.closeReassignModal();
                    
                    // Refresh data
                    this.submit();

                } catch (error) {
                    console.error("Error reassigning driver:", error);
                    let errorMsg = 'Error al reasignar el conductor';
                    if (error.response && error.response.data && error.response.data.error) {
                        errorMsg = error.response.data.error;
                    }
                    this.$store.commit('snackbar_change_color', 'error');
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', errorMsg);
                    setTimeout(this.clear, 3000);

                } finally {
                    this.loadingReassign = false;
                }
            },
            mandarCorrecionDocumentos () {
                console.log('Docuemntos selccionados = ', this.selectedDocument)
                this.loadingDocumentsCorrection = true
                // Filtrar solo IDs válidos (no null, no undefined, no strings vacios)
                const validIds = this.selectedDocument
                    .filter(id => id !== null && id !== undefined && id !== '')
                    .map(id => Number(id)) // Asegurar que todos sean números
                    .filter(id => !isNaN(id)) // Remover NaN
                console.log('IDs válidos a enviar = ', validIds)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/create-documents-correction',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        ids: validIds,
                        idInvitationByUser: this.info_invitation[0].id
                    }
                };
                axios(config)
                    .then(response => {
                        this.loadingDocumentsCorrection = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_application_submitted_successfully'))
                        this.dialogDocumentationCorrection = false
                        this.get_detail(this.info_invitation[0].id)
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loadingDocumentsCorrection = false
                        console.log(error)
                    })
            },
            downloadFile() {
                const link = document.createElement('a')
                link.href = this.fileUrl
                link.download = this.fileName
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            },
            openDialog(fileUrl) {
                // 🔧 Ajusta esta ruta a tu estructura de archivos
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialogShowDocument = true
            },
            showDocumentation() {
                this.loadingDocumentation = true
                this.selectedDocument = []
                
                // Validaciones previas
                if (!this.info_invitation || this.info_invitation.length === 0) {
                    this.loadingDocumentation = false
                    return
                }
                
                const userGuest = this.info_invitation[0].idUserGuest
                console.log('showDocumentation llamado')
                
                if (!userGuest) {
                    this.loadingDocumentation = false
                    this.$store.commit('snackbar_change_message', 'Error: usuario no identificado')
                    return
                }
                
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-documents-by-user/' + userGuest + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                                
                axios(config)
                    .then(response => {
                        
                        if (!response.data || response.data.length === 0) {
                            // Aún así, procesar documentationByInvitation para mostrar tarjetas vacías
                            this.missingDocumentations = this.processDocumentation([], this.info_invitation[0].documentationByInvitation)
                            this.faltaArchivo = true
                        } else {
                            // Procesar documentos
                            this.missingDocumentations = this.processDocumentation(response.data, this.info_invitation[0].documentationByInvitation)
                        }
                        
                        this.loadingDocumentation = false
                        
                        // Abrir el modal
                        this.$nextTick(() => {
                            this.dialogDocumentos = true
                        })
                    })
                    .catch(error => {
                        this.loadingDocumentation = false
                        console.error('✗ Error al cargar documentos:', error)
                        this.missingDocumentations = []
                        this.$store.commit('snackbar_change_message', 'Error al cargar documentos: ' + (error.message || error))
                    })
            },
            processDocumentation(documentationsByUser, documentationsByInvitation) {       
                let processedDocumentations = []
                
                // Validar entrada
                const safeDocsByUser = Array.isArray(documentationsByUser) ? documentationsByUser : []
                
                // Procesar documentationsByInvitation - manejar tanto objetos como IDs
                let validInvDocs = []
                if (Array.isArray(documentationsByInvitation)) {
                    validInvDocs = documentationsByInvitation.filter(d => {
                        if (!d) return false
                        // Manejar caso donde idDocumentation es un objeto con estructura {id, name, ...}
                        if (d.idDocumentation && typeof d.idDocumentation === 'object' && d.idDocumentation.id != null) {
                            return true
                        }
                        // Manejar caso donde idDocumentation es un ID directo (número o string)
                        if ((typeof d.idDocumentation === 'number' || typeof d.idDocumentation === 'string') && d.idDocumentation) {
                            return true
                        }
                        return false
                    })
                }
                
                // Si no hay documentos requeridos por invitación, mostrar todos los de la API
                if (validInvDocs.length === 0) {
                    for(let j = 0; j < safeDocsByUser.length; j++) {
                        if(safeDocsByUser[j] && safeDocsByUser[j].idDocumentation &&
                           typeof safeDocsByUser[j].idDocumentation === 'object' &&
                           safeDocsByUser[j].idDocumentation.id != null &&
                           safeDocsByUser[j].is_current) {
                            const doc = {
                                id: safeDocsByUser[j].id,
                                documentationId: safeDocsByUser[j].idDocumentation.id,
                                name: safeDocsByUser[j].idDocumentation.name,
                                file: safeDocsByUser[j].file,
                                is_valid: safeDocsByUser[j].is_valid,
                                is_company_document: safeDocsByUser[j].idDocumentation.is_company_document,
                                uploaded_at: safeDocsByUser[j].uploaded_at
                            }
                            processedDocumentations.push(doc)
                        }
                    }
                } else {
                    // Procesar documentos requeridos por la invitación
                    for(let i = 0; i < validInvDocs.length; i++) {
                        let found = false
                        
                        // Extraer el ID requerido (puede ser objeto o ID directo)
                        let requiredDocId = null
                        if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                            requiredDocId = validInvDocs[i].idDocumentation.id
                        } else if (typeof validInvDocs[i].idDocumentation === 'number' || typeof validInvDocs[i].idDocumentation === 'string') {
                            requiredDocId = validInvDocs[i].idDocumentation
                        }
                        
                        // Buscar en documentos del usuario
                        for(let j = 0; j < safeDocsByUser.length; j++) {
                            if(safeDocsByUser[j] && safeDocsByUser[j].idDocumentation &&
                               typeof safeDocsByUser[j].idDocumentation === 'object' &&
                               safeDocsByUser[j].idDocumentation.id != null &&
                               safeDocsByUser[j].is_current) {
                                
                                // Comparar IDs
                                if (safeDocsByUser[j].idDocumentation.id === requiredDocId) {
                                    found = true
                                    // Usar todos los datos de la API
                                    const doc = {
                                        id: safeDocsByUser[j].id,
                                        documentationId: safeDocsByUser[j].idDocumentation.id,
                                        name: safeDocsByUser[j].idDocumentation.name,
                                        file: safeDocsByUser[j].file,
                                    is_valid: safeDocsByUser[j].is_valid,
                                    is_company_document: safeDocsByUser[j].idDocumentation.is_company_document,
                                    uploaded_at: safeDocsByUser[j].uploaded_at
                                }
                                    processedDocumentations.push(doc)
                                    break
                                }
                            }
                        }
                        if(!found) {
                            // Documento requerido pero no proporcionado
                            
                            // Extraer nombre del documento requerido
                            let docName = 'Documento sin nombre'
                            if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                                docName = validInvDocs[i].idDocumentation.name || 'Documento sin nombre'
                            } else if (validInvDocs[i].name) {
                                docName = validInvDocs[i].name
                            }
                            
                            // Extraer is_company_document
                            let isCompanyDoc = false
                            if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                                isCompanyDoc = validInvDocs[i].idDocumentation.is_company_document || false
                            } else if (validInvDocs[i].is_company_document !== undefined) {
                                isCompanyDoc = validInvDocs[i].is_company_document
                            }
                            
                            const missingDoc = {
                                id: null,
                                documentationId: requiredDocId,
                                name: docName,
                                file: null,
                                is_valid: false,
                                is_company_document: isCompanyDoc,
                                uploaded_at: null
                            }
                            processedDocumentations.push(missingDoc)
                        }
                    }
                }
                
                // Verificar si hay documentos faltantes
                let hasMissing = false
                for (let i = 0; i < processedDocumentations.length; i++) {
                    if (processedDocumentations[i].file === null) {
                        hasMissing = true
                        break
                    }
                }
                this.faltaArchivo = hasMissing
                
                // Agregar documentos INE
                if (this.info_invitation && this.info_invitation[0]) {
                    this.ineFront.file = this.info_invitation[0].guest_ine_frente
                    this.ineBack.file = this.info_invitation[0].guest_ine_atras
                    if (this.ineFront.file) {
                        processedDocumentations.push({...this.ineFront, is_valid: true})
                    }
                    if (this.ineBack.file) {
                        processedDocumentations.push({...this.ineBack, is_valid: true})
                    }
                }
                
                return processedDocumentations
            },
            compareDocumentation(documentationsByInvitation, documentationsByUser) {
                // Mantener este método por compatibilidad
                return this.processDocumentation(documentationsByUser, documentationsByInvitation)
            },
            fillTransportFields (item) {
              this.typeService = item.download
              this.case_plates = item.case_plates
              this.container_platform_plates = item.container_platform_plates
              this.transport_line = item.transport_line
              this.supplier_customer_name = item.supplier_customer_name
            },
            addAccessCarrierData () {
              this.loading = true
              let URL_ACCESS = 'https://empresa-service.intrare.app/empresas/access/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_NO_CODE = 'https://empresa-service.intrare.app/bitacora/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_CONTRACTOR = 'https://empresa-service.intrare.app/access_contractor/update/transport_data/' + this.idAccess + '/'
              let URL_FINAL = ''
              if(this.accessQRCode === false) {
                URL_FINAL = URL_ACCESS_NO_CODE
              } else {
                if (this.accessContractor === true) {
                    URL_FINAL = URL_ACCESS_CONTRACTOR
                } else {
                    URL_FINAL = URL_ACCESS
                }
              }
              // console.log('Tipo de Servicio = ', this.typeService)
              if (this.typeService !== null && this.case_plates === null && this.container_platform_plates === null && this.transport_line === null && this.supplier_customer_name === null)
              {
                  this.bandConfirm = true
                  this.loading = false
              } else
                if (this.typeService === null) {
                  this.loading = false
                } else {
                  const config = {
                    method: 'patch',
                    url: URL_FINAL,
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept-Language': this.language,
                      'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      download: this.typeService,
                      case_plates: this.case_plates,
                      container_platform_plates: this.container_platform_plates,
                      transport_line: this.transport_line,
                      supplier_customer_name: this.supplier_customer_name
                    }
                  };
                  axios(config)
                      .then(response => {
                        this.loading = false
                        this.dialogTransport = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('data_update_successfully'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                      })
                      .catch(error => {
                        this.loading = false
                        console.log(error)
                      })
                }
            },
            vigente(currentDate, expirationDate) {
              let currentDataConvert = new Date(currentDate)
              let expirationDateConvert = expirationDate.substring(3, 6) + expirationDate.substring(0, 2) + expirationDate.substring(5, 10)
              var expirationDateConvertFull = new Date(expirationDateConvert)
              // console.log('currentDateConvert', currentDataConvert)
              // console.log('expirationConvert = ', expirationDateConvertFull)
              if (currentDataConvert < expirationDateConvertFull)
                  return true
              else
                return false
            },
            boolFormat(value){
                if (value === true)
                    return  this.$t('Si')
                return 'No'
            },
            estadoFormat(value){
                if (value === 0)
                    return  this.$t('pending_authorization')
                if (value === 1)
                    return  this.$t('adentro')
                if (value === 2)
                    return  this.$t('completado')
                if (value === 3)
                    return  this.$t('no_firmado') + '/' + this.$t('completado')
                if (value === 4)
                    return  this.$t('deny')
                if (value === 5)
                    return  this.$t('waiting_room')
            },
            typeAccessFormat(value) {
              if (value === true)
                return  this.$t('acceso_con_codigo')
              return  this.$t('acceso_sin_codigo')
            },
            boolFormat2(value){
                if (value.vehicle === true)
                    return  this.$t('Si')
                return 'No'
            },
            hostNameParkFormat(value){
                return value.first_name + ' ' + value.last_name
            },
            parkNameFormat(value){
                return value.park_name
            },
            subjectFormat(value){
                return value.subject
            },
            dateFormat(value){
                const [day, month, year] = value.split('-')
                return `${day}/${month}/${year}`
            },
            dateParkFormat(value){
                const [year, month, day] = value.dateInv.split('-')
                return `${day}/${month}/${year}` + ' ' + value.timeInv
            },
            typeInvitationFormat(value){
                if (value === 0)
                    return  this.$t('normal')
                if (value === 1)
                    return  this.$t('empresarial')
                if (value === 2)
                    return  this.$t('recurrente')
            },
            typeInvitationParkFormat(value){
                if (value.typeInv === 0)
                    return  this.$t('normal')
                if (value.typeInv === 1)
                    return  this.$t('empresarial')
                if (value.typeInv === 2)
                    return  this.$t('recurrente')
            },
            exportPdfInvitationInboxCompanies() {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationRecivedCompany = this.$t('headerInvitationRecivedCompany')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var columns = [{
                    tipo: this.$t('Tipo'),
                    confirmed: this.$t('asistira'),
                    fecha_hora: this.$t('fecha_hora'),
                    anfitrion: this.$t('Anfitrion'),
                    area: 'Andén/Área',
                    asunto: this.$t('Asunto'),
                    automovil: this.$t('mensaje_vehiculo'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.mappedInvitacionesRecibidasExport,
                    didDrawPage: function (data) {
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        doc.text(headerInvitationRecivedCompany, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        var str = page + doc.internal.getNumberOfPages()
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    margin: { top: 80 }
                })
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('invitationsInboxCompanies' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfInvitationInboxParks() {
                var normal = this.$t('normal')
                var empresarial = this.$t('empresarial')
                var recurrente = this.$t('recurrente')
                var si = this.$t('Si')
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationRecivedPark = this.$t('headerInvitationRecivedPark')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var headerDate = this.$t('fecha_hora')
                var columns = [{
                    typeInv: this.$t('Tipo'),
                    confirmed: this.$t('asistira'),
                    dateInv: this.$t('fecha_hora'),
                    hostFirstName: this.$t('Anfitrion'),
                    park_name: this.$t('Parque'),
                    subject: this.$t('Asunto'),
                    vehicle: this.$t('mensaje_vehiculo'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.parking_reservations_received,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerInvitationRecivedPark, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 0) {
                            if (data.row.section === 'body') {
                                if(data.row.raw.invitation.typeInv.toString() === '0'){
                                    data.cell.text = normal
                                }
                                if(data.row.raw.invitation.typeInv.toString() === '1'){
                                    data.cell.text = empresarial
                                }
                                if(data.row.raw.invitation.typeInv.toString() === '2'){
                                    data.cell.text = recurrente
                                }
                            }
                        }
                        if (data.column.index === 1) {
                            if(data.cell.text.toString() === 'true'){
                                data.cell.text = si
                            }
                            if(data.cell.text.toString() === 'false'){
                                data.cell.text = 'No'
                            }
                        }
                        if (data.column.index === 2) {
                            if (data.row.section === 'body') {
                                const [year, month, day] = data.row.raw.invitation.dateInv.toString().split('-')
                                data.cell.text = `${day}/${month}/${year}` + ' ' +  data.row.raw.invitation.timeInv.toString()
                            }
                        }
                        if (data.column.index === 3) {
                            if (data.row.section === 'body') {
                                data.cell.text = data.row.raw.host.first_name.toString() + ' ' + data.row.raw.host.last_name.toString()
                            }
                        }
                        if (data.column.index === 4) {
                            if (data.row.section === 'body') {
                                data.cell.text = data.row.raw.invitation.park_name.toString()
                            }
                        }
                        if (data.column.index === 5) {
                            if (data.row.section === 'body') {
                                data.cell.text = data.row.raw.invitation.subject.toString()
                            }
                        }
                        if (data.column.index === 6) {
                            if (data.row.section === 'body') {
                                if (data.row.raw.invitation.vehicle.toString() === 'true') {
                                    data.cell.text = si
                                }
                                if (data.row.raw.invitation.vehicle.toString() === 'false') {
                                    data.cell.text = 'No'
                                }
                            }
                        }
                    },
                    margin: { top: 80 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('invitationsInboxPark' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfInvitationSent () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerInvitationSent = this.$t('headerInvitationSent')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var columnas = {
                    tipo: this.$t('Tipo'),
                    confirmed: this.$t('asistira'),
                    fecha_envio: this.$t('fecha_envio'),
                    fecha_hora: this.$t('fecha_hora'),
                    anfitrion: this.$t('Anfitrion'),
                    visitante: this.$t('Visitante'),
                    area: 'Andén/Área',
                    automovil: this.$t('mensaje_vehiculo')
                }
                if (this.getProfile.enable_shipments) {
                    columnas.is_external_invitation = 'Externa'
                }
                var columns = [columnas]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.mappedInvitacionesExport,
                    didDrawPage: function (data) {
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        var str = page + doc.internal.getNumberOfPages()
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    margin: { top: 80 }
                })
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('invitationsSent' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfAccess () {
                var adentro = this.$t('adentro')
                var completado = this.$t('completado')
                var denegado = this.$t('deny')
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessExcel = this.$t('headerAccessExcel')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos.length.toString()
                var columns = [{
                    guestFName: this.$t('Visitante'),
                    guestLName: this.$t('Apellido'),
                    companyName: this.$t('Empresa'),
                    temperature: this.$t('temperature'),
                    estado: this.$t('estado'),
                    fecha_hora_acceso: this.$t('hora_acceso'),
                    fecha_hora_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                    hostLastName: this.$t('Apellido'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.accesos,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessExcel, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                            if (data.column.index === 4) {
                                if (data.cell.text.toString() === '1') {
                                    data.cell.text = adentro
                                } else
                                if (data.cell.text.toString() === '2') {
                                    data.cell.text = denegado
                                } else {
                                    data.cell.text = completado
                                }
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.addPage()
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessNoCode = this.$t('accesos_sin_codigo')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_without_code.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    empresa: this.$t('Empresa'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesosWithoutCodeForExcel,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 3) {
                            if(data.cell.text.toString() === ''){
                                data.cell.text = pendiente
                            }
                        }
                    },
                    margin: { top: 90 }
                })

                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfAccessUnion () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var adentro = this.$t('adentro')
                var pending_authorization = this.$t('pending_authorization')
                var completado = this.$t('completado')
                var waiting_room = this.$t('waiting_room')
                var no_firmado_completado = this.$t('no_firmado') + '/' + this.$t('completado')
                var denegado = this.$t('deny')
                var headerAccessNoCode = this.$t('headerAccess')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var con_codigo = this.$t('acceso_con_codigo')
                var sin_codigo = this.$t('acceso_sin_codigo')
                var total = 'Total: ' + this.access.length.toString()
                var columns = [{
                    access_qr_code: this.$t('type_of_access'),
                    guest_full_name: this.$t('Visitante'),
                    company_name: this.$t('Empresa'),
                    status: this.$t('estado'),
                    datetime_arrival: this.$t('hora_llegada'),
                    datetime_checkin: this.$t('hora_acceso'),
                    datetime_checkout: this.$t('hora_salida'),
                    host_full_name: this.$t('Anfitrion'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                          if (data.column.index === 0) {
                            if (data.cell.text.toString() === 'true') {
                              data.cell.text = con_codigo
                            } else {
                              data.cell.text = sin_codigo
                            }
                          }
                          if (data.column.index === 6) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 5) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 3) {
                            if (data.cell.text.toString() === '0') {
                              data.cell.text = pending_authorization
                            }
                            if (data.cell.text.toString() === '1') {
                              data.cell.text = adentro
                            }
                            if (data.cell.text.toString() === '2') {
                              if (data.row.raw.exit_pass === true) {
                                data.cell.text = completado
                              } else {
                                data.cell.text = no_firmado_completado
                              }
                            }
                            if (data.cell.text.toString() === '3') {
                              data.cell.text = no_firmado_completado
                            }
                            if (data.cell.text.toString() === '4') {
                              data.cell.text = denegado
                            }
                            if (data.cell.text.toString() === '5') {
                              data.cell.text = waiting_room
                            }
                          }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }
                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                console.log('Fecha = ', today)
                return today
            },
            get_current_date2: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            split_date: function(date, date2){
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            get_invitaciones: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                let URL = ''
                if (this.getProfile.roll === 5) {
                  console.log('ADMINISTRADORRRRRR .....')
                  URL = 'https://empresa-service.intrare.app/get_invByDateRangeOnlyAdmin/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/'
                }
                if (this.getProfile.roll === 1) {
                  URL = 'https://empresa-service.intrare.app/get_invByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/'
                  console.log('EMPLEADOOOO .....')
                }
                console.log(yyyy, mm ,dd, '-', yyyy2, mm2, dd2)
                this.loading_data_invitaciones = true
                const configNormal = {
                    method: 'get',
                    url: URL,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                const dateStr1 = `${yyyy}-${mm}-${dd}`;
                const dateStr2 = `${yyyy2}-${mm2}-${dd2}`;
                const configShipments = {
                    method: 'get',
                    url: `https://empresa-service.intrare.app/shipments/sent-invitations/?created_at__gte=${dateStr1}&created_at__lte=${dateStr2}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                Promise.all([
                    axios(configNormal).catch(error => { console.error("Error fetching normal sent invs:", error); return { data: [] }; }),
                    axios(configShipments).catch(error => { console.error("Error fetching shipment sent invs:", error); return { data: { results: [] } }; })
                ]).then(([resNormal, resShipments]) => {
                    let normalInvs = (resNormal.data === "" || !resNormal.data) ? [] : resNormal.data;
                    
                    let shipmentInvs = [];
                    if (resShipments.data && resShipments.data.results) {
                        shipmentInvs = resShipments.data.results;
                    } else if (Array.isArray(resShipments.data)) {
                        shipmentInvs = resShipments.data;
                    }

                    this.invitaciones = normalInvs.concat(shipmentInvs);
                    this.loading_data_invitaciones = false;
                }).catch(error => {
                    this.loading_data_invitaciones = false;
                    console.log("Error in Promise.all for sent invitations:", error);
                });
            },
            get_shared: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                console.log(yyyy, mm ,dd, '-', yyyy2, mm2, dd2)
                this.loading_data_shared = true
                const configNormal = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_share_inv/userByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                const dateStr1 = `${yyyy}-${mm}-${dd}`;
                const dateStr2 = `${yyyy2}-${mm2}-${dd2}`;

                axios(configNormal)
                .then(resNormal => {
                    this.invitaciones_shared = (resNormal.status === 204 || !resNormal.data) ? [] : resNormal.data;
                    this.loading_data_shared = false;
                })
                .catch(error => {
                    this.loading_data_shared = false;
                    console.error("Error fetching shared invs:", error);
                });
            },
            get_enterprise_invitations: function () {
                this.loading_enterprise_invitations = true
                let params = {};
                if (this.date && this.date.trim() !== '') {
                    params.date_from = this.date;
                }
                if (this.date2 && this.date2.trim() !== '') {
                    params.date_to = this.date2;
                }
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/EnterpriseInv/enterprise_invs/received/',
                    params: params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data && response.data.results) {
                            this.enterprise_invitations = response.data.results || [];
                        } else if (Array.isArray(response.data)) {
                            this.enterprise_invitations = response.data;
                        } else {
                            this.enterprise_invitations = [];
                        }
                        this.loading_enterprise_invitations = false;
                    })
                    .catch(error => {
                        this.loading_enterprise_invitations = false;
                        console.error("Error fetching enterprise invitations:", error);
                        this.enterprise_invitations = [];
                    });
            },
            get_normal_invitations: function () {
                this.loading_normal_invitations = true
                let params = {};
                if (this.date && this.date.trim() !== '') {
                    params.date_from = this.date;
                }
                if (this.date2 && this.date2.trim() !== '') {
                    params.date_to = this.date2;
                }
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/EnterpriseInv/normal_invs/received/',
                    params: params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data && response.data.results) {
                            this.normal_invitations = response.data.results || [];
                        } else if (Array.isArray(response.data)) {
                            this.normal_invitations = response.data;
                        } else {
                            this.normal_invitations = [];
                        }
                        this.loading_normal_invitations = false;
                    })
                    .catch(error => {
                        this.loading_normal_invitations = false;
                        console.error("Error fetching normal invitations:", error);
                        this.normal_invitations = [];
                    });
            },
            getRecurrentEnterpriseInvitations () {
                this.loadingRecurrentEnterpriseInvitations = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/EnterpriseInv/get/recurrying/invs/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.recurrentEnterpriseInvitations = Array.isArray(response.data) ? response.data : []
                        this.loadingRecurrentEnterpriseInvitations = false
                    })
                    .catch(error => {
                        this.loadingRecurrentEnterpriseInvitations = false
                        console.log(error)
                    })
                  .finally(
                    this.loadingRecurrentEnterpriseInvitations = false
                  )
            },
            get_assigned_invitations: function () {
                this.loading_assigned_invitations = true
                let params = {};
                
                if (this.search_assigned_employee && this.search_assigned_employee.trim() !== '') {
                    params.search = this.search_assigned_employee;
                }
                if (this.date && this.date.trim() !== '') {
                    params.date_from = this.date;
                }
                if (this.date2 && this.date2.trim() !== '') {
                    params.date_to = this.date2;
                }
                if (this.filter_assigned_confirmed !== null && this.filter_assigned_confirmed !== undefined) {
                    params.confirmed = this.filter_assigned_confirmed;
                }
                
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/EnterpriseInv/enterprise_invs/assigned/',
                    params: params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data && response.data.results) {
                            this.assigned_invitations = response.data.results || [];
                        } else if (Array.isArray(response.data)) {
                            this.assigned_invitations = response.data;
                        } else {
                            this.assigned_invitations = [];
                        }
                        this.loading_assigned_invitations = false;
                    })
                    .catch(error => {
                        this.loading_assigned_invitations = false;
                        console.error("Error fetching assigned invitations:", error);
                        this.assigned_invitations = [];
                    });
            },
            get_assigned_shipments: function () {
                this.loading_assigned_shipments = true
                let params = {};
                
                if (this.search_assigned_employee && this.search_assigned_employee.trim() !== '') {
                    params.search = this.search_assigned_employee;
                }
                if (this.date && this.date.trim() !== '') {
                    params.date_from = this.date;
                }
                if (this.date2 && this.date2.trim() !== '') {
                    params.date_to = this.date2;
                }
                if (this.filter_assigned_confirmed !== null && this.filter_assigned_confirmed !== undefined) {
                    params.confirmed = this.filter_assigned_confirmed;
                }
                
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/assigned-shipments/',
                    params: params,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data && response.data.results) {
                            this.assigned_shipments = response.data.results || [];
                        } else if (Array.isArray(response.data)) {
                            this.assigned_shipments = response.data;
                        } else {
                            this.assigned_shipments = [];
                        }
                        this.loading_assigned_shipments = false;
                    })
                    .catch(error => {
                        this.loading_assigned_shipments = false;
                        console.error("Error fetching assigned shipments:", error);
                        this.assigned_shipments = [];
                    });
            },
            get_invitaciones_recibidas: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_invitaciones_recibidas = true
                
                const configNormal = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/userByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                const dateStr1 = `${yyyy}-${mm}-${dd}`;
                const dateStr2 = `${yyyy2}-${mm2}-${dd2}`;
                const configShipments = {
                    method: 'get',
                    url: `https://empresa-service.intrare.app/shipments/external-invitations/?created_at__gte=${dateStr1}&created_at__lte=${dateStr2}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };

                Promise.all([
                    axios(configNormal).catch(error => { console.error("Error fetching normal received invs:", error); return { data: [] }; }),
                    axios(configShipments).catch(error => { console.error("Error fetching shipment received invs:", error); return { data: { results: [] } }; })
                ]).then(([resNormal, resShipments]) => {
                    let normalInvs = (resNormal.data === "" || !resNormal.data) ? [] : resNormal.data;
                    
                    let shipmentInvs = [];
                    if (resShipments.data && resShipments.data.results) {
                        shipmentInvs = resShipments.data.results;
                    } else if (Array.isArray(resShipments.data)) {
                        shipmentInvs = resShipments.data;
                    }

                    this.invitaciones_recibidas = normalInvs.concat(shipmentInvs);
                    this.loading_data_invitaciones_recibidas = false;
                }).catch(error => {
                    this.loading_data_invitaciones_recibidas = false;
                    console.log("Error in Promise.all for received invitations:", error);
                });
            },
            get_invitaciones_recibidas_park: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_invitaciones_recibidas_park = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/received/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.invitaciones_recibidas_park = []
                        else
                            this.invitaciones_recibidas_park = response.data
                        this.loading_data_invitaciones_recibidas_park = false
                    })
                    .catch(error => {
                        this.loading_data_invitaciones_recibidas_park = false
                        console.log(error)
                    })
            },
            get_parking_reservations_received: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_reservations_received = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/reservations/list/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?role=beneficiary&date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                } else {
                    url += '?role=beneficiary';
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_reservations_received = [];
                        else
                            this.parking_reservations_received = Array.isArray(response.data) ? response.data : [];
                        this.loading_parking_reservations_received = false;
                    })
                    .catch(error => {
                        this.loading_parking_reservations_received = false
                        console.log(error)
                    })
            },
            get_parking_reservations_sent: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_reservations_sent = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/reservations/list/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?role=owner&date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                } else {
                    url += '?role=owner';
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_reservations_sent = [];
                        else
                            this.parking_reservations_sent = Array.isArray(response.data) ? response.data : [];
                        this.loading_parking_reservations_sent = false;
                    })
                    .catch(error => {
                        this.loading_parking_reservations_sent = false
                        console.log(error)
                    })
            },
            get_parking_invitations_received: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_received = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/received/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_invitations_received = {invitations: [], pending_referred: []};
                        else
                            this.parking_invitations_received = response.data;
                        this.loading_parking_received = false;
                    })
                    .catch(error => {
                        this.loading_parking_received = false
                        console.log(error)
                    })
            },
            get_parking_invitations_sent: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_parking_sent = true
                let url = 'https://empresa-service.intrare.app/Parking/invitations/sent/';
                if (yyyy && mm && dd && yyyy2 && mm2 && dd2) {
                    url += `?date_from=${yyyy}-${mm}-${dd}&date_to=${yyyy2}-${mm2}-${dd2}`;
                }
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.parking_invitations_sent = {invitations: [], pending_referred: []};
                        else
                            this.parking_invitations_sent = response.data;
                        this.loading_parking_sent = false;
                    })
                    .catch(error => {
                        this.loading_parking_sent = false
                        console.log(error)
                    })
            },
            get_access_union_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_access2 = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRangeUnion/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                          if (Array.isArray(response.data)) {
                              this.access = response.data
                          } else {
                              this.access = []
                          }
                        this.loading_data_access2 = false
                    })
                    .catch(error => {
                        this.loading_data_access2 = false
                        console.log(error)
                    })

            },
            get_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.data === "")
                            this.accesos = []
                        else
                            this.accesos = response.data
                        this.loading_data_accesos = false
                    })
                    .catch(error => {
                        this.loading_data_accesos = false
                        console.log(error)
                    })

            },
            get_access_without_code_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacoraByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.data.length > 0)
                            this.accesos_without_code = response.data
                        else
                            this.accesos_without_code = []
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            firmar: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_pase_salida_firmado'))
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_detail(id) {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/' + id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.info_invitation = Array.isArray(response.data) ? response.data : [response.data]
                        this.dialog_detail_invit = true
                    })
                    .catch(error => {
                        this.dialog_detail_invit = false
                        console.log(error)
                    })

            },
            openIneUpdateRequest() {
                this.ineUpdateChannel = this.ineUpdateChannels.length
                    ? this.ineUpdateChannels[0].value
                    : null
                this.dialogIneUpdateRequest = true
            },
            async submitIneUpdateRequest() {
                const invitation = this.info_invitation[0]
                if (!invitation || !this.ineUpdateChannels.some(channel => channel.value === this.ineUpdateChannel)) {
                    this.$store.commit('snackbar_change_color', 'error')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'Selecciona un canal de contacto válido para el invitado.')
                    return
                }

                let url
                let data
                if (invitation.ine_update_pending === false) {
                    if (!invitation.idUserGuest) {
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'No se encontró el identificador del invitado para crear la solicitud.')
                        return
                    }
                    url = 'https://empresa-service.intrare.app/ine-update-requests/'
                    data = {
                        guest_id: invitation.idUserGuest,
                        channel: this.ineUpdateChannel
                    }
                } else if (invitation.ine_update_pending === true) {
                    if (!invitation.id_ine_update_pending) {
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'No se encontró el identificador de la solicitud pendiente para reenviarla.')
                        return
                    }
                    url = 'https://empresa-service.intrare.app/ine-update-requests/' + invitation.id_ine_update_pending + '/resend/'
                    data = { channel: this.ineUpdateChannel }
                } else {
                    this.$store.commit('snackbar_change_color', 'error')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'No se pudo determinar el estado de la solicitud de actualización de INE.')
                    return
                }

                this.loadingIneUpdateRequest = true
                try {
                    await this.$axios({
                        method: 'post',
                        url: url,
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: data
                    })
                    this.$store.commit('snackbar_change_color', 'success')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', invitation.ine_update_pending
                        ? 'La solicitud de actualización de fotos de INE fue reenviada.'
                        : 'La solicitud de actualización de fotos de INE fue enviada.')
                    this.dialogIneUpdateRequest = false
                    this.get_detail(invitation.id)
                    setTimeout(this.clear, 3000)
                } catch (error) {
                    const responseData = error.response && error.response.data
                    const errorMessage = responseData && (responseData.detail || responseData.message)
                        ? responseData.detail || responseData.message
                        : error.message || 'No fue posible procesar la solicitud de actualización de INE.'
                    this.$store.commit('snackbar_change_color', 'error')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', errorMessage)
                } finally {
                    this.loadingIneUpdateRequest = false
                }
            },
            get_detail_recibidas_park(item) {
                this.info_invitation_recibida_park = Array.isArray(item) ? item : [item]
                this.dialog_detail_invit_recibidas_park = true
            },
            get_detail_recibidas(id) {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_inv/' + id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.info_invitation_recibida = Array.isArray(response.data) ? response.data : [response.data]
                        this.dialog_detail_invit_recibidas = true
                    })
                    .catch(error => {
                        this.dialog_detail_invit_recibidas = false
                        console.log(error)
                    })
            },
            get_access_detail(id) {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.info_access = Array.isArray(response.data) ? response.data : [response.data]
                        this.dialog_detail_access = true
                    })
                    .catch(error => {
                        this.dialog_detail_access = false
                        console.log(error)
                    })

            },
            fill_fields: function(item){
                this.data_accesos_without_code = item
                console.log(this.data_accesos_without_code)
            },
            fill_fields_sin_codigo: function(item){
                this.data_accesos_sin_codigo = item
            },
            cancelar_invitacion(){
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/Invitation/Canceled/' + this.id_invitacion_eliminar + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                };
                axios(config).then(ok => {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_canceled'))
                    setTimeout(this.clear, 3000);
                    this.dialog_elimnar = false
                    this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            confirmar_invitacion(a_qr, confirmacion){
                if(confirmacion === 'True')
                    this.loading_si = true
                else
                    this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/setConfirmed_Appointment/'+ a_qr +'/' + confirmacion + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas = false
                        this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        this.get_enterprise_invitations()
                        this.get_normal_invitations()
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)}
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
            },
            rechazar_invitacion(qr_code){
                this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/declineInvitation/'+ qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('invitacion_rechazada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas = false
                        this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        this.get_enterprise_invitations()
                        this.get_normal_invitations()
                        this.loading_no = false
                    })
                    .catch(error => {
                        console.error('Error rechazando invitación:', error)
                        this.$store.commit('snackbar_activate_true')
                        var mensajeError = this.$t('error_rechazando_invitacion')
                        if(error.response && error.response.data && error.response.data.message){
                            mensajeError = error.response.data.message
                        }
                        this.$store.commit('snackbar_change_message', mensajeError)
                        this.loading_no = false
                    })
            },
            confirmar_invitacion_park(pk, confirmacion){
                if(confirmacion === 'True')
                    this.loading_si = true
                else
                    this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/InvitationPark/confirm/'+ pk,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas_park = false
                        this.get_parking_reservations_received(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)}
                        if(confirmacion === 'True')
                            this.loading_si = false
                        else
                            this.loading_no = false
                    })
            },
            rechazar_invitacion_park(pk){
                this.loading_no = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/InvitationPark/decline/'+ pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('invitacion_rechazada'))
                        setTimeout(this.clear, 3000);
                        this.dialog_detail_invit_recibidas_park = false
                        this.get_parking_reservations_received(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        this.loading_no = false
                    })
                    .catch(error => {
                        console.error('Error rechazando invitación de parque:', error)
                        this.$store.commit('snackbar_activate_true')
                        var mensajeError = this.$t('error_rechazando_invitacion')
                        if(error.response && error.response.data && error.response.data.message){
                            mensajeError = error.response.data.message
                        }
                        this.$store.commit('snackbar_change_message', mensajeError)
                        this.loading_no = false
                    })
            },
            submit: function(){
                this.split_date(this.date, this.date2)
                this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_shared(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_invitaciones_recibidas(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_parking_reservations_received(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_parking_reservations_sent(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_enterprise_invitations()
                this.get_normal_invitations()
                this.get_assigned_invitations()
                this.get_assigned_shipments()
            },
            clear(){
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            setChangeHour (qrCode, time) {
                this.hora = time
                this.qr_code_changeHour = qrCode
                this.dialog_changeHour = true
            },
            changeHourInvitation( ){
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/updateTimeInvitation/'+ this.qr_code_changeHour + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        newTime: this.hora
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitation_changed'))
                        setTimeout(this.clear, 3000)
                        this.dialog_changeHour = false
                        this.dialog_detail_invit = false
                        this.get_invitaciones(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)
                        }
                    })
            },
            notifyAccess (firstName, lastName, id){
                this.loadingNotifyAccess = true
                var fullName = firstName + ' ' + lastName

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/grantAccess_pushNotification2/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        'name_Guest': fullName,
                        'idInvitationByUser': id
                    }
                };
                axios(config)
                    .then(response => {
                        this.loadingNotifyAccess = false
                        this.dialog_detail_invit = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_acceso_exito'))
                        setTimeout(this.clear, 3000);
                        console.log('Notificado!!!')
                    })
                    .catch(error => {
                        this.loadingNotifyAccess = false
                        console.log(error)
                    })
            },
            notifyAccessNoCode (id, fullname){
                this.loadingNotifyAccess = true

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/grant_access_no_code_push_notification/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        'nombre': fullname,
                        'id': id
                    }
                };
                axios(config)
                    .then(response => {
                        this.loadingNotifyAccess = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_acceso_exito'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                        console.log('Notificado!!!')
                    })
                    .catch(error => {
                        this.loadingNotifyAccess = false
                        console.log(error)
                    })
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            formatDateDDMMYYYY(dateStr) {
                if (!dateStr || dateStr === 'pendiente' || dateStr === 'N/A' || dateStr === '-') return dateStr;
                let match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})(.*)$/);
                if (match) {
                    let year = match[1];
                    let month = match[2];
                    let day = match[3];
                    let rest = match[4].replace('T', ' ').replace('Z', '');
                    return `${day}/${month}/${year}${rest}`;
                }
                return dateStr;
            },
            normalizeApiDate(dateStr) {
                if (!dateStr || typeof dateStr !== 'string') return ''
                const cleanDate = dateStr.split('T')[0].split(' ')[0]
                const p = cleanDate.split('-')
                if (p.length !== 3) return cleanDate
                if (p[0].length === 4) return cleanDate
                return `${p[2]}-${p[1]}-${p[0]}`
            },
            normalizeApiTime(timeStr) {
                if (!timeStr || typeof timeStr !== 'string') return ''
                return timeStr.split(':').slice(0, 2).join(':')
            },
            getParkingTimeRange(item) {
                const startTime = this.normalizeApiTime(item && item.start_time)
                const endTime = this.normalizeApiTime(item && item.end_time)
                if (startTime && endTime) return `${startTime} - ${endTime}`
                return startTime || endTime || ''
            },
            dateSortValue(normalizedDate, normalizedTime) {
                const isoDate = this.normalizeApiDate(normalizedDate)
                if (!isoDate) return 0

                let timePart = normalizedTime || ''
                if (timePart.includes('-')) {
                    timePart = timePart.split('-')[0].trim()
                }
                if (!timePart) timePart = '00:00'

                const isoDateTime = `${isoDate}T${timePart.length === 5 ? `${timePart}:00` : timePart}`
                const ts = new Date(isoDateTime).getTime()
                if (!Number.isNaN(ts)) return ts
                return new Date(`${isoDate}T00:00:00`).getTime()
            },
            get_info_invitation(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Invs/get/contact/data/' + this.qrCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(result => {
                        this.dataQR = result.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            changeGuest () {
                console.log(this.email.id)
                this.loadingChangeGuest = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/EnterpriseInv/changeGuest/'+ this.qrCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        idGuest: this.email.id === undefined ? 0 : this.email.id
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loadingChangeGuest = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitation_changed'))
                        setTimeout(this.clear, 3000)
                        this.dialogChangeGuest = false
                        this.getRecurrentEnterpriseInvitations()
                    })
                    .catch(error => {
                        this.loadingChangeGuest = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data){
                            this.errores = error.response.data
                            this.errores_seg = error.response.data.id_usuario
                            console.log(this.errores)
                        }
                    })
            },
            add_comments () {
                this.loadingNotifyAccess = true
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/comments/'+ this.id_acceso + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      motivo_no_firma: this.comments
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loadingNotifyAccess = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('add_comments_success'))
                        setTimeout(this.clear, 3000)
                        this.dialogComments = false
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loadingNotifyAccess = false
                        console.log(error)
                    })
            },
            add_veto () {
                this.errores = []
                this.loadingNotifyAccess = true
                const config = {
                    method: 'POST',
                    url: 'https://empresa-service.intrare.app/empresas/vetos/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      id_usuario: this.idGuest,
                      motivo: this.motivo,
                      tipo: this.tipo,
                      fecha_inicial: this.tipo === 1 ? this.fecha_inicial : null,
                      fecha_final: this.tipo === 1 ? this.fecha_final :null,
                    }
                }
                axios(config)
                    .then(ok => {
                        this.bandVeto = true
                        this.loadingNotifyAccess = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('user_banned'))
                        setTimeout(this.clear, 3000)
                        this.dialogVeto = false
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loadingNotifyAccess = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            // REQ-007: Métodos para gestión de asignaciones internas
            openReleaseDriverModal(driver) {
                this.selectedDriver = driver
                this.releaseReason = ''
                this.dialogReleaseDriver = true
                this.dialogDrivers = false
            },
            openReasignVehicleModal(driver) {
                this.selectedDriver = driver
                this.reassignVehicleReason = ''
                this.selectedNewVehicle = ''
                this.loadAvailableVehicles()
                this.dialogReassignVehicle = true
                this.dialogDrivers = false
            },
            openCancelAssignmentModal(driver) {
                this.selectedDriver = driver
                this.cancellationReason = ''
                this.sendCancellationNotification = true
                this.dialogCancelAssignment = true
                this.dialogDrivers = false
            },
            loadAvailableVehicles() {
                this.loadingVehicles = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/vehicles/?is_active=true',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.availableVehicles = response.data.vehicles || response.data.results || response.data || []
                    })
                    .catch(error => {
                        console.log('Error cargando vehículos:', error)
                        this.availableVehicles = []
                    })
                    .finally(() => {
                        this.loadingVehicles = false
                    })
            },
            submitReleaseDriver() {
                if (!this.releaseReason.trim()) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'Debes ingresar un motivo')
                    return
                }

                this.loadingAssignmentAction = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/internal-drivers/release/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        assignment_id: this.selectedDriver.assignment_id,
                        reason: this.releaseReason
                    }
                }

                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Chofer liberado exitosamente')
                        this.dialogReleaseDriver = false
                        this.openDriversModal(this.selectedInvitation, this.canReassignDrivers)
                    })
                    .catch(error => {
                        console.log('Error liberando chofer:', error)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al liberar chofer')
                    })
                    .finally(() => {
                        this.loadingAssignmentAction = false
                    })
            },
            submitReassignVehicle() {
                if (!this.selectedNewVehicle) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'Debes seleccionar un vehículo')
                    return
                }
                if (!this.reassignVehicleReason.trim()) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'Debes ingresar un motivo')
                    return
                }

                this.loadingAssignmentAction = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/internal-drivers/reassign-vehicle/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        assignment_id: this.selectedDriver.assignment_id,
                        new_vehicle_id: this.selectedNewVehicle.id,
                        reason: this.reassignVehicleReason
                    }
                }

                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Vehículo reasignado exitosamente')
                        this.dialogReassignVehicle = false
                        this.openDriversModal(this.selectedInvitation, this.canReassignDrivers)
                    })
                    .catch(error => {
                        console.log('Error reasignando vehículo:', error)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al reasignar vehículo')
                    })
                    .finally(() => {
                        this.loadingAssignmentAction = false
                    })
            },
            submitCancelAssignment() {
                if (!this.cancellationReason.trim()) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'Debes ingresar un motivo de cancelación')
                    return
                }

                this.loadingAssignmentAction = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/internal-drivers/cancel/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        assignment_id: this.selectedDriver.assignment_id,
                        cancellation_reason: this.cancellationReason,
                        send_notification: this.sendCancellationNotification
                    }
                }

                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Asignación cancelada exitosamente')
                        this.dialogCancelAssignment = false
                        this.openDriversModal(this.selectedInvitation, this.canReassignDrivers)
                    })
                    .catch(error => {
                        console.log('Error cancelando asignación:', error)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al cancelar asignación')
                    })
                    .finally(() => {
                        this.loadingAssignmentAction = false
                    })
            }
        }
    }
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}


    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
